import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import {RadioButton} from 'primereact/radiobutton';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {Toast} from 'primereact/toast';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputSwitch} from 'primereact/inputswitch';
import {Fieldset} from 'primereact/fieldset';
import { ROLES,LEAVE_STATUS, INSTITUTION_LIST, VACATION_FOR, COURSE_LIST , YEARS } from './LeaveRequestConst';
import ViewActions from './ViewActions';
import PDF from '../../../assets/pdf/Policy_Leaves.pdf';
import { removeString, DateFormetter, REDIRECT_TO_URL, UPLOAD_NAME_CONCAT , DECRYPT} from '../../../shared/utility';
import { DROPDOWN_CONFIG, CALENDAR_CONFIG, EXAMINATION_ID, LEAVE_REQUEST_ID } from '../../../shared/Config';
import axios from '../../../axios-url';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import UploadImage from '../../../assets/images/uploadImg.svg';
import moment from 'moment';


const INPUT = 1;
const DROPDOWN = 2;
const MULTIDROPDOWN = 3;
const CHECKBOX = 4;
const RADIO = 5;
const TEXTAREA = 6;
const DATETIMEPICKER = 7;
const DATEPICKER = 8;
const CONTAINER = 9;
const SWITCH = 10;
const FILE = 11;
const DEPCONTAINERS =[ 
    {
        field_001001001024: {
            FieldName   : '001001001024',
            FieldLabel  : 'Dependent name',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001025: {
            FieldName   : '001001001025',
            FieldLabel  : 'Dependent Relation',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001026: {
            FieldName   : '001001001026',
            FieldLabel  : 'Age',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'int',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001027: {
            FieldName   : '001001001027',
            FieldLabel  : 'Gender',
            FieldValue  : 'Male',
            FieldType   : RADIO,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001028: {
            FieldName   : '001001001028',
            FieldLabel  : 'Date of Ticket From',
            FieldValue  : '',
            FieldType   : DATEPICKER,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001029: {
            FieldName   : '001001001029',
            FieldLabel  : 'Date of Ticket To',
            FieldValue  : '',
            FieldType   : DATEPICKER,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001030: {
            FieldName   : '001001001030',
            FieldLabel  : 'Ticket classification',
            FieldValue  : 'One Way',
            FieldType   : RADIO,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001031: {
            FieldName   : '001001001031',
            FieldLabel  : 'Ticket Route From',
            FieldValue  : '',
            FieldType   : DROPDOWN,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001032: {
            FieldName   : '001001001032',
            FieldLabel  : 'Ticket Route To',
            FieldValue  : '',
            FieldType   : DROPDOWN,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001033: {
            FieldName   : '001001001033',
            FieldLabel  : 'Present Location',
            FieldValue  : 'In KSA',
            FieldType   : RADIO,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001001034: {
            FieldName   : '001001001034',
            FieldLabel  : 'Select Dependent',
            FieldValue  : '',
            FieldType   : DROPDOWN,
            DataType    : 'string',
            ParentFieldId: '001001000023',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
      
}];

const EXAMCONTAINER = [
    {
        field_001001002029: {
            FieldName   : '001001002029',
            FieldLabel  : 'Exam name',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000028',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001002030: {
            FieldName   : '001001002030',
            FieldLabel  : 'Subject Name',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000028',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        },
        field_001001002031: {
            FieldName   : '001001002031',
            FieldLabel  : 'Exam Date',
            FieldValue  : '',
            FieldType   : DATEPICKER,
            DataType    : 'string',
            ParentFieldId: '001001000028',
            ChildRowNmbr: 1,
            type: 'attributes',
            FieldId : '',
            
        }
    },
]

const FORMCONTAINER = [
    {
        field_001001003032: {
            FieldName   : '001001003032',
            FieldLabel  : 'Selected Form',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000031',
            ChildRowNmbr: 1,
            type: 'forms',
            FieldId : '',
            
        },
        field_001001003033: {
            FieldName   : '001001003033',
            FieldLabel  : 'Selected Person',
            FieldValue  : '',
            FieldType   : DROPDOWN,
            DataType    : 'string',
            ParentFieldId: '001001000031',
            ChildRowNmbr: 1,
            type: 'forms',
            FieldId : '',
            
        },
        field_001001003034: {
            FieldName   : '001001003034',
            FieldLabel  : 'Target Date',
            FieldValue  : '',
            FieldType   : DATEPICKER,
            DataType    : 'string',
            ParentFieldId: '001001000031',
            ChildRowNmbr: 1,
            type: 'forms',
            FieldId : '',
            
        }
    }    
]

const ATTACHMENTCONTAINER = [
    {
        field_001001004034: {
            FieldName   : '001001004034',
            FieldLabel  : 'File Name',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000033',
            ChildRowNmbr: 1,
            type: 'attachments',
            FieldId : '',
        },
        field_001001004035: {
            FieldName   : '001001004035',
            FieldLabel  : 'File Extension',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000033',
            ChildRowNmbr: 1,
            type: 'attachments',
            FieldId : '',
            
        },
        field_001001004036: {
            FieldName   : '001001004036',
            FieldLabel  : 'File Path',
            FieldValue  : '',
            FieldType   : INPUT,
            DataType    : 'string',
            ParentFieldId: '001001000033',
            ChildRowNmbr: 1,
            type: 'attachments',
            FieldId : '',
            
        }
    }   
]

class LeaveRequest extends Component {
    state = {
        requestedForIsSaudi: false,
        ticketRequired: false,
        allowButton: true,
        currentStatus : ROLES,
        display:false,
        loading:false,
        type: 'add',
        visaActionDetails : [],
        selectPerson : 'All',
        transportActionDetails : [],
        ticketActionDetails : [],
        expandedRows: null, 
        examDate: '',
        examName: '',
        subjectName: '',
        hasAcknowledged:false,
        hasAttachment:false,
        stages : [
            {
                AllowApprove : true,
                AllowForms : false,
                AllowAttachments : true,
                AllowActions : false,
                Description:"",
                stageFields  : {
                    field_001001000001: {
                        FieldName   : '001001000001',
                        FieldLabel  : 'Request For',
                        FieldValue  : null,
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000002: {
                        FieldName   : '001001000002',
                        FieldLabel  : 'Request Date',
                        FieldValue  : new Date(),
                        FieldType   : DATEPICKER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000003: {
                        FieldName   : '001001000003',
                        FieldLabel  : 'Leave Type',
                        FieldValue  : '',
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000004: {
                        FieldName   : '001001000004',
                        FieldLabel  : 'Starting Date',
                        FieldValue  : '',
                        FieldType   : DATEPICKER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',                        
                        ContainerFields : null
                    },
                    field_001001000005: {
                        FieldName   : '001001000005',
                        FieldLabel  : 'Ending Date',
                        FieldValue  : '',
                        FieldType   : DATEPICKER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',                        
                        ContainerFields : null
                    },
                    field_001001000006: {
                        FieldName   : '001001000006',
                        FieldLabel  : 'Half Day Leave',
                        FieldValue  : false,
                        FieldType   : SWITCH,
                        DataType    : 'int',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',                        
                        ContainerFields : null
                    },
                    field_001001000007: {
                        FieldName   : '001001000007',
                        FieldLabel  : 'Reporting date',
                        FieldValue  : null,
                        FieldType   : DATEPICKER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',                        
                        ContainerFields : null
                    },
                    field_001001000008: {
                        FieldName   : '001001000008',
                        FieldLabel  : 'Ticket Status',
                        FieldValue  : 'Company',
                        FieldType   : RADIO,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000009: {
                        FieldName   : '001001000009',
                        FieldLabel  : 'Sadad Paid',
                        FieldValue  : false,
                        FieldType   : SWITCH,
                        DataType    : 'int',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000010: {
                        FieldName   : '001001000010',
                        FieldLabel  : 'Contact during vacation',
                        FieldValue  : '',
                        FieldType   : INPUT,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000011: {
                        FieldName   : '001001000011',
                        FieldLabel  : 'Mobile',
                        FieldValue  : localStorage.getItem('mobile'),
                        FieldType   : INPUT,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000012: {
                        FieldName   : '001001000012',
                        FieldLabel  : 'Email address',
                        FieldValue  : localStorage.getItem('email'),
                        FieldType   : INPUT,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000013: {
                        FieldName   : '001001000013',
                        FieldLabel  : 'Vacation For',
                        FieldValue  : 'For me only',
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000014: {
                        FieldName   : '001001000014',
                        FieldLabel  : 'Employee name',
                        FieldValue  : '',
                        FieldType   : INPUT,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000015: {
                        FieldName   : '001001000015',
                        FieldLabel  : 'Age',
                        FieldValue  : '',
                        FieldType   : INPUT,
                        DataType    : 'int',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000016: {
                        FieldName   : '001001000016',
                        FieldLabel  : 'Gender',
                        FieldValue  : 'Male',
                        FieldType   : RADIO,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000017: {
                        FieldName   : '001001000017',
                        FieldLabel  : 'Date of Ticket From ',
                        FieldValue  : '',
                        FieldType   : DATEPICKER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000018: {
                        FieldName   : '001001000018',
                        FieldLabel  : 'Date of Ticket To',
                        FieldValue  : '',
                        FieldType   : DATEPICKER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000019: {
                        FieldName   : '001001000019',
                        FieldLabel  : 'Ticket classification',
                        FieldValue  : 'One Way',
                        FieldType   : RADIO,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000020: {
                        FieldName   : '001001000020',
                        FieldLabel  : 'Ticket Route From',
                        FieldValue  : null,
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000021: {
                        FieldName   : '001001000021',
                        FieldLabel  : 'Ticket Route To',
                        FieldValue  : null,
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    },
                    field_001001000022: {
                        FieldName   : '001001000022',
                        FieldLabel  : 'Present Location',
                        FieldValue  : 'In KSA',
                        FieldType   : RADIO,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        
                        ContainerFields : null
                    }, //21
                    field_001001000023 : { //22
                        FieldName   : '001001000023',
                        FieldLabel  : 'Dependent Details',
                        FieldValue  : 'Dependent Details',
                        FieldType   : CONTAINER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : DEPCONTAINERS,
                    },
                    // Examination Leave Type 23 Start
                    field_001001000024 : { 
                        FieldName   : '001001000024',
                        FieldLabel  : 'Select Institution',
                        FieldValue  : '',
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null,
                    },
                    field_001001000025 : {
                        FieldName   : '001001000025',
                        FieldLabel  : 'Select Course',
                        FieldValue  : '',
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null,
                    },
                    field_001001000026 : {
                        FieldName   : '001001000026',
                        FieldLabel  : 'Select Institution',
                        FieldValue  : '',
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null,
                    },
                    field_001001000027 : { //26
                        FieldName   : '001001000027',
                        FieldLabel  : 'Attach Exam Time Table',
                        FieldValue  : '',
                        FieldType   : INPUT,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null,
                    },
                    field_001001000028 : { //27
                        FieldName   : '001001000028',
                        FieldLabel  : 'Examination Details',
                        FieldValue  : 'Examination Details',
                        FieldType   : CONTAINER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : EXAMCONTAINER,
                    },
                    // Examination Leave Type 23 End
                    field_001001000029: { // For Visa 28
                        FieldName   : '001001000029',
                        FieldLabel  : 'Visa Required',
                        FieldValue  : false,
                        FieldType   : SWITCH,
                        DataType    : 'int',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000030: { // For Visa 29
                        FieldName   : '001001000030',
                        FieldLabel  : 'Visa Status',
                        FieldValue  : 'Company',
                        FieldType   : RADIO,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000031 : { //30 Stage1 Forms 001001000031
                        FieldName   : '001001000031',
                        FieldLabel  : 'Forms',
                        FieldValue  : 'Forms',
                        FieldType   : CONTAINER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'forms',
                        FieldId : '',
                        ContainerFields : null, //FORMCONTAINER
                    },
                    field_001001000032 : { //31 Stage1 Remarks
                        FieldName   : '001001000032',
                        FieldLabel  : 'Remarks',
                        FieldValue  : '',
                        FieldType   : TEXTAREA,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null,
                    },
                    field_001001000033 : { //32 Stage1 Attachement 001001000033
                        FieldName   : '001001000033',
                        FieldLabel  : 'Attachments',
                        FieldValue  : 'Attachments',
                        FieldType   : CONTAINER,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attachments',
                        FieldId : '',
                        ContainerFields : ATTACHMENTCONTAINER,
                    },
                    field_001001000034: { 
                        FieldName   : '001001000034',
                        FieldLabel  : 'Ticket Required',
                        FieldValue  : false,
                        FieldType   : SWITCH,
                        DataType    : 'int',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000035: { 
                        FieldName   : '001001000035',
                        FieldLabel  : 'Delegation of Authority Required',
                        FieldValue  : false,
                        FieldType   : SWITCH,
                        DataType    : 'int',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000036: {
                        FieldName   : '001001000036',
                        FieldLabel  : 'Delegate To',
                        FieldValue  : null,
                        FieldType   : DROPDOWN,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',
                        ContainerFields : null
                    },
                    field_001001000037: {
                        FieldName   : '001001000037',
                        FieldLabel  : 'Leave Days',
                        FieldValue  : '',
                        FieldType   : INPUT,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        FieldId : '',                        
                        ContainerFields : null
                    },
                    // field_001001000038: { 
                    //     FieldName   : '001001000038',
                    //     FieldLabel  : 'Disclaimer',
                    //     FieldValue  : false,
                    //     FieldType   : SWITCH,
                    //     DataType    : 'int',
                    //     ParentFieldId: '000',
                    //     ChildRowNmbr: 1,
                    //     type: 'attributes',
                    //     FieldId : '',
                    //     ContainerFields : null
                    // },
                }
            },
            {
                AllowAttachments : false,
                AllowForms : false,
                AllowActions : false,
                stageFields  : {
                    field_001002000001 : { //32 Stage2 Action  001002000001
                        FieldName   : '001002000001',
                        FieldLabel  : 'Remarks',
                        FieldValue  : '',
                        FieldType   : TEXTAREA,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        ContainerFields : [],
                    },
                }
            },
            {
                AllowAttachments : false,
                AllowForms : false,
                AllowActions : true,
                stageFields  : {
                    field_001003000001 : { //33 Stage3 Action  001002000003
                        FieldName   : '001003000001',
                        FieldLabel  : 'Remarks',
                        FieldValue  : '',
                        FieldType   : TEXTAREA,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        ContainerFields : null,
                    },
                    
                }
            },
            {
                AllowAttachments : false,
                AllowForms : false,
                AllowActions : false,
                stageFields  : {
                    field_001004000001 : { //32 Stage2 Action  001002000001
                        FieldName   : '001004000001',
                        FieldLabel  : 'Remarks',
                        FieldValue  : '',
                        FieldType   : TEXTAREA,
                        DataType    : 'string',
                        ParentFieldId: '000',
                        ChildRowNmbr: 1,
                        type: 'attributes',
                        ContainerFields : [],
                    },
                }
            },
        ],
     
        stage1Forms : [],
        loadOnce : true,
        EmpID : null,
        selectedForm : '',
        sendToWho : '',
        targetDate : '',
        fileExtension : '',
        fileName : '',
        filePath : '',
        selectedAction : "",
        selectedPerson : "",
        selectedDepartment : "",
        selectedTargetDate : "",
        actionComments : "",
        actionStatus : "",
        loading : false,
        dynamicSupervisorDisplay:false,
        DynamicSupervisor : null,
        DynamicSupervisorsList  : null,
        reqStatus : null,
        requestNum : null,
        currentStage : 0,
        DynamicRequestID : null,
        actionDefenitions : [],
        actionType : null,
        minDate : new Date(),
        requestactionid : null,
        RETURN_TICKET_AIRLINE: "",
        RETURN_TICKET_DATE_OF_JOURNEY: "",
        RETURN_TICKET_FROM_AIRPORT: "",
        RETURN_TICKET_NUMBER: "",
        RETURN_TICKET_PNR: "",
        RETURN_TICKET_TO_AIRPORT: "",
        TICKET_AIRLINE: "",
        TICKET_CANCEL_BEFORE_DATE1: "",
        TICKET_CANCEL_BEFORE_DATE2: "",
        TICKET_CANCEL_BEFORE_DATE3: "",
        TICKET_CANCEL_VALUE_BEFORE_DATE1: "",
        TICKET_CANCEL_VALUE_BEFORE_DATE2: "",
        TICKET_CANCEL_VALUE_BEFORE_DATE3: "",
        TICKET_DATE_OF_JOURNEY: "",
        TICKET_FROM_AIRPORT: "",
        TICKET_NUMBER: "",
        TICKET_PNR: "",
        TICKET_TO_AIRPORT: "",
        ticketComments: "",
        ticketStatus : 1,
        fromDate : "",
        toDate : "",
        EXITREENTRYVISANUMBER : "",
        EXITREENTRYVISAISSUEDATE : "",
        EXITREENTRYVISAEXPIRYDATE : "",
        VISITINGCOUNTRYVISANUMBER : "",
        VISITINGCOUNTRYISSUEDATE : "",
        VISITINGCOUNTRYEXPIRYDATE : "",
        visaComments : "",
        visaStatus:1,
        TRANSPORTATIONDATETIME: "",
        TRANSPORTATIONFROM: "",
        TRANSPORTATIONTO: "",
        transportComments: "",
        transportStatus:1,
        iqamaStatus:1,
        iqamaComments : '',
        delegatePopup : false,
        Delegate_WF_Level_ID : null,
        popupName : '',
        apiName : '',
        popupTitle : 'Select Supervisor',
        reqType : null,
        RETURN_TO_WF_LEVEL_ID: null,
        iqamaActionDetails : [],
        requestedFor: false ,
        attachmentData:[],
        timeoffTypeId: false,
    }
    

    delegateRequest = (name,apiName) => {
        this.setState({delegatePopup:true,popupName:name,apiName:apiName});
    }

    setReturnRequest = () => {
        setTimeout(()=>{
            this.setState({reqType:'return',popupTitle : 'Select Return To'});
        },2000)
    }

    saveRequest = (type,redirect='',Return_WF_Level_ID='',att=false,st=0) => {
        // const { location = {} } = this.props; ***
        this.setState({loading:true,reqType:null,popupTitle : 'Select Supervisor'});
        let filterAttribute = [];
        let groupAttributes = [];
        var RequestType = '';
        var RequestedFor = '';
        var Remarks = '';
        var fieldSequence = 1;
        var RequestedDate = new Date();
        var FromDate = new Date();
        var ToDate =new Date();
        var hasatt = this.state.hasAttachment;
        //let id = this.props.match.params.id; 
        
        // let idparam = this.props.match.params.id; 
        // let params = new URLSearchParams(idparam);
        // let id = params.get('');
        if (this.props.tableLists.requestID
            !== undefined || this.props.tableLists.requestID
            !== '' || this.props.tableLists.requestID
            !== null) {
            var id = this.props.tableLists.requestID
        }

      //  let id = this.props.match.params.id; 
            
      

        if(this.state.stages && this.state.stages.length > 0){
            var err = false;
            filterAttribute = this.state.stages.map(((stageList,stageIndex) => {
                let stageFields = stageList.stageFields;
                let stageNumber = parseInt('001')+stageIndex;
                let StageSequence = stageIndex;
                  
                Object.entries(stageFields).map(([key, field],index) => {
                    
                    if(field.FieldName==='001001000003'){
                        RequestType = field.FieldValue;
                    }else if(field.FieldName==='001001000001'){
                        RequestedFor = field.FieldValue;
                    }else if(field.FieldName=== '001001000032'){
                        Remarks = field.FieldValue;
                    }else if(field.FieldName==='001001000002'){
                        RequestedDate = field.FieldValue;
                    }else if(field.FieldName==='001001000004'){
                        FromDate = field.FieldValue;
                    }else if(field.FieldName==='001001000005'){
                        ToDate = field.FieldValue;
                    }

                    if(field.FieldName==='001001000001' && field.FieldValue ===null){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000002' && field.FieldValue === ''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000003' && field.FieldValue === ''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000004' && field.FieldValue ===''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000005' && field.FieldValue ===''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000007' && field.FieldValue ===''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000010' && field.FieldValue ===''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000011' && field.FieldValue ===''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000012' && field.FieldValue ===''){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    }else if(field.FieldName==='001001000013' && field.FieldValue ===null){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';
                    } else if(field.FieldName==='001001000032' && field.FieldValue ===null){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' field is required'});
                        err = true
                        return '';  
                    } else if(field.FieldName==='001001000037' && field.FieldValue =='-1'){
                        this.growl.show({severity: 'error', summary: null, detail: field.FieldLabel +' Wrong Leave Days.Please check the from date,to date or ensure approved work schedule in place for given date range '});
                        err = true
                        return '';  
                    }
                    const sick = ['cc252e45-aa24-4a52-bf89-0c2e48708e47','c514cddb-48f5-457b-9b72-0f11a2c0c697','186cb786-d9ad-4035-8921-714ba5b7166f','186cb786-d9ad-4035-8921-714ba5b7167f','186cb786-d9ad-4035-8921-714ba5b7168f']
                    if (sick.indexOf(RequestType) > -1 && hasatt == false && StageSequence ==0)
                    {
                        this.growl.show({severity: 'error', summary: null, detail:'Attachment is mandatory for this specific leave type'});
                        this.setState({loading:false});
                        err = true
                        return '';
                    }
                    if(err){
                        this.setState({loading:false});
                    }

                    
                    
                    if(field.ContainerFields === null){
                        
                        let val = {
                            ChildRowNmbr: field.ChildRowNmbr,
                            DataType: field.DataType,
                            FieldDescription: field.FieldLabel,
                            FieldName: field.FieldName,
                            FieldType: field.FieldType,
                            FieldValue: (field.FieldType === 7 || field.FieldType === 8) || (field.FieldType === "7" || field.FieldType === "8") ? moment(field.FieldValue).format('MM/DD/YYYY') : field.FieldValue,
                            ParentFieldId: field.ParentFieldId,
                            stageNum : stageNumber,
                            processNum : '001',
                            FieldSequence : fieldSequence++,
                            IsActive: true,
                            CompanyID : this.props.loggedUserDetail.CompanyId,
                            StageSequence : StageSequence,
                            ContainerType: field.type,
                        }

                        if(this.state.type === 'edit' && field.FieldId!==undefined  && field.FieldId!==''){
                            val.FieldId = field.FieldId;
                        }
                        
                        groupAttributes.push(val);
                    
                    
                    }else{

                        let val1 = {
                            ChildRowNmbr: field.ChildRowNmbr,
                            DataType: field.DataType,
                            FieldDescription: field.FieldLabel,
                            FieldName: field.FieldName,
                            FieldType: field.FieldType,
                            FieldValue: (field.FieldType === 7 || field.FieldType === 8) || (field.FieldType === "7" || field.FieldType === "8") ? moment(field.FieldValue).format('MM/DD/YYYY') : field.FieldValue,
                            ParentFieldId: field.ParentFieldId,
                            stageNum : stageNumber,
                            processNum : '001',
                            FieldSequence : fieldSequence++,
                            IsActive: true,
                            CompanyID : this.props.loggedUserDetail.CompanyId,
                            StageSequence : StageSequence,
                            ContainerType: field.type,
                        }
                        if(this.state.type === 'edit' && field.FieldId!==undefined  && field.FieldId!==''){
                            val1.FieldId = field.FieldId;
                        }
                        groupAttributes.push(val1);


                        let containerFields = field.ContainerFields;
                        Object.entries(containerFields).map(([containerKey, containerField],containerIndex) => {
                            Object.entries(containerField).map(([containerFKey, containerFField],containerFIndex) => {

                                let val2 = {
                                    ChildRowNmbr: containerFField.ChildRowNmbr,
                                    DataType: containerFField.DataType,
                                    FieldDescription: containerFField.FieldLabel,
                                    FieldName: containerFField.FieldName,
                                    FieldType: containerFField.FieldType,
                                    FieldValue: (containerFField.FieldType === 7 || containerFField.FieldType === 8) || (field.FieldType === "7" || field.FieldType === "8") ? moment(containerFField.FieldValue).format('MM/DD/YYYY') : containerFField.FieldValue,
                                    ParentFieldId: containerFField.ParentFieldId,
                                    stageNum : stageNumber,
                                    processNum : '001',
                                    FieldSequence : fieldSequence++,
                                    IsActive: true,
                                    CompanyID : this.props.loggedUserDetail.CompanyId,
                                    StageSequence: StageSequence,
                                    ContainerType: field.type
                                }

                                if(this.state.type === 'edit' && containerFField.FieldId!==undefined  && containerFField.FieldId!==''){
                                    val2.FieldId = containerFField.FieldId;
                                }
                                groupAttributes.push(val2);
                            });
                        });
                    }
                    
                    
                })
              
                return stageList;
            }))
        }

        var RequestActionData = [];
        if(this.state.actionDefenitions && this.state.actionDefenitions.length > 0 && this.state.currentStage === 2){
            RequestActionData = this.state.actionDefenitions.map((list,index) => {
                return {
                    Requestid : list.requestid,
                    DeligateToEmployeeId : '',
                    DelicateToEmpEmailId : '',
                    DeligateFromDate : '',
                    DeligateToDate : '',
                    Comments : '',
                    AssignedByEmployeeId : this.props.loggedUserDetail.empID,
                    Createddate : new Date(),
                    Updatedby : '',
                    Updateddate : '',
                    ApprovalPathId : '',
                    ApprovalPathSequence : '',
                    PreviousDate : '',
                    EscalationLevel1 : '',
                    EscalationLevel1Dt : '',
                    EscalationLevel2 : '',
                    EscalationLevel2Dt : '',
                    EscalationLevel3 : '',
                    EscalationLevel3Dt : '',
                    EscalationLevel4 : '',
                    EscalationLevel4Dt : '',
                    ReportingToEmpId1 : '',
                    ReportingToEmpId2 : '',
                    ReportingToEmpId3 : '',
                    TicketNumber : '',
                    TicketPnr : '',
                    TicketAirline : '',
                    TicketFromAirport : '',
                    TicketToAirport : '',
                    TicketDateOfJourney : '',
                    ReturnTicketNumber : '',
                    ReturnTicketPnr : '',
                    ReturnTicketAirline : '',
                    ReturnTicketFromAirport : '',
                    ReturnTicketToAirport : '',
                    ReturnTicketDateOfJourney : '',
                    TicketCancelBeforeDate1 : '',
                    TicketCancelValueBeforeDate1 : '',
                    TicketCancelBeforeDate2 : '',
                    TicketCancelValueBeforeDate2 : '',
                    TicketCancelBeforeDate3 : '',
                    TicketCancelValueBeforeDate3 : '',
                    Exitreentryvisanumber : '',
                    Exitreentryvisaissuedate : '',
                    Exitreentryvisaexpirydate : '',
                    Visitingcountryvisanumber : '',
                    Visitingcountryissuedate : '',
                    Visitingcountryexpirydate : '',
                    Transportationdatetime : '',
                    Transportationfrom : '',
                    Transportationto : '',
                    CompanyId : this.props.loggedUserDetail.CompanyId,
                    Actionnum : list.actionnum,
                    Createdby : this.props.loggedUserDetail.empID,
                    Actiontype : list.actiontype,
                    Responsibledepartment : list.responsibledepartment,
                    AssignedTo : list.assignedTo,
                    Targetdate : list.targetdate,
                    StatusId : list.status,
                    Actiondescription : list.actiondescription,
                    //Requestactionid:list.requestactionid,
                }
            })
        }

        if(!err){
            let data = {
                FromDate : moment(FromDate).format('MM/DD/YYYY'),
                ToDate : moment(ToDate).format('MM/DD/YYYY'),
                VisaCount : 0,
                TicketCount : 0,
                RequestDesc : 'Leave Request',
                IsActive: true,
                RequestDate : RequestedDate,                
                LoginEmployeeID : this.props.loggedUserDetail.empID,
                CompanyID : this.props.loggedUserDetail.CompanyId,
                Remark : Remarks,
                RequestedFor : RequestedFor,
                RequestType : RequestType,
                ProcessID : LEAVE_REQUEST_ID,
                RequestAttributes : groupAttributes,
                Requestattachments : this.state.attachmentData.map((el, index) => {
                    index++
                    return{
                        Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                        Requestid :'00000000-0000-0000-0000-000000000000',
                        SiNo: index ,
                        UploadPath:el.filePath ,
                        FileName:el.fileName ,
                        Extension :el.fileExtension,
                        Createdby: this.props.loggedUserDetail.empID ,
                        Createddate: moment().format('MM/DD/YYYY') ,
                        Updatedby: this.props.loggedUserDetail.empID ,
                        Updateddate: moment().format('MM/DD/YYYY') ,
                        CompanyId: this.props.loggedUserDetail.CompanyId ,
                        Stagenum: 0 ,
                    }
                }),
                Requestforms : [],
                Requestactions : [],
                StageSequence :  this.state.currentStage
            };
            


            if(this.state.type === 'add'){
                data.EmpID = this.props.loggedUserDetail.empID;
                if(this.state.DynamicRequestID!=null){
                    data.RequestID = this.state.DynamicRequestID;
                }
            }

            if(this.state.type === 'edit'){ 
                data.RequestID = id;
                if(RequestActionData && RequestActionData.length > 0){
                    data.Requestactions = RequestActionData;
                }
            }
           
            let model = 'requestSave';
            if(this.state.DynamicSupervisor !==null){
                data.DynamicSupervisor = this.state.DynamicSupervisor;
            }
            if(type === 'submit'){
                model = 'LeaveRequest';
            }
            else if(type==='actionSubmit'){
                model = 'Action_Update';

                let actionData = [];

                if(this.state.ticketActionDetails && this.state.ticketActionDetails.length > 0){
                    actionData = this.state.ticketActionDetails.map(ticket => {
                        return{
                                Requestid : id,
                                Requestactionid:ticket.requestactionid,
                                DeligateToEmployeeId : '',
                                DelicateToEmpEmailId : '',
                                DeligateFromDate : '',
                                DeligateToDate : '',                    
                                AssignedByEmployeeId : '',
                                Createddate : new Date(),
                                Updatedby : '',
                                Updateddate : '',
                                ApprovalPathId : '',
                                ApprovalPathSequence : '',
                                PreviousDate : '',
                                EscalationLevel1 : '',
                                EscalationLevel1Dt : '',
                                EscalationLevel2 : '',
                                EscalationLevel2Dt : '',
                                EscalationLevel3 : '',
                                EscalationLevel3Dt : '',
                                EscalationLevel4 : '',
                                EscalationLevel4Dt : '',
                                ReportingToEmpId1 : '',
                                ReportingToEmpId2 : '',
                                ReportingToEmpId3 : '',
                                Comments : ticket.ticketComments,
                                TicketNumber : ticket.TICKET_NUMBER,
                                TicketPnr : ticket.TICKET_PNR,
                                TicketAirline : ticket.TICKET_AIRLINE,
                                TicketFromAirport : ticket.TICKET_FROM_AIRPORT,
                                TicketToAirport : ticket.TICKET_TO_AIRPORT,
                                TicketDateOfJourney : ticket.TICKET_DATE_OF_JOURNEY,
                                ReturnTicketNumber : ticket.RETURN_TICKET_NUMBER,
                                ReturnTicketPnr : ticket.RETURN_TICKET_PNR,
                                ReturnTicketAirline : ticket.RETURN_TICKET_AIRLINE,
                                ReturnTicketFromAirport : ticket.RETURN_TICKET_FROM_AIRPORT,
                                ReturnTicketToAirport : ticket.RETURN_TICKET_TO_AIRPORT,
                                ReturnTicketDateOfJourney : ticket.RETURN_TICKET_DATE_OF_JOURNEY,
                                TicketCancelBeforeDate1 : ticket.TICKET_CANCEL_BEFORE_DATE1,
                                TicketCancelValueBeforeDate1 : ticket.TICKET_CANCEL_VALUE_BEFORE_DATE1,
                                TicketCancelBeforeDate2 : ticket.TICKET_CANCEL_BEFORE_DATE2,
                                TicketCancelValueBeforeDate2 : ticket.TICKET_CANCEL_VALUE_BEFORE_DATE2,
                                TicketCancelBeforeDate3 : ticket.TICKET_CANCEL_BEFORE_DATE3,
                                TicketCancelValueBeforeDate3 : ticket.TICKET_CANCEL_VALUE_BEFORE_DATE3,
                                Exitreentryvisanumber : '',
                                Exitreentryvisaissuedate :  '',
                                Exitreentryvisaexpirydate : '',
                                Visitingcountryvisanumber : '',
                                Visitingcountryissuedate : '',
                                Visitingcountryexpirydate : '',
                                Transportationdatetime : '',
                                Transportationfrom : '',
                                Transportationto : '',
                                CompanyId : this.props.loggedUserDetail.CompanyId,
                                Actionnum : ticket.Actionnum,
                                Createdby : ticket.Createdby,
                                Actiontype : ticket.Actiontype,
                                Responsibledepartment : ticket.Responsibledepartment,
                                AssignedTo : ticket.AssignedTo,
                                Targetdate : ticket.Targetdate,
                                StatusId : (ticket.ticketStatus===null) ? 1 : ticket.ticketStatus,
                                Actiondescription : ticket.Actiondescription,
                            }   
                    })

                }
                if(this.state.visaActionDetails && this.state.visaActionDetails.length > 0){
                    actionData = this.state.visaActionDetails.map(visa => {
                        return{
                                Requestid : id,
                                Requestactionid:visa.requestactionid,
                                DeligateToEmployeeId : '',
                                DelicateToEmpEmailId : '',
                                DeligateFromDate : '',
                                DeligateToDate : '',                    
                                AssignedByEmployeeId : '',
                                Createddate : new Date(),
                                Updatedby : '',
                                Updateddate : '',
                                ApprovalPathId : '',
                                ApprovalPathSequence : '',
                                PreviousDate : '',
                                EscalationLevel1 : '',
                                EscalationLevel1Dt : '',
                                EscalationLevel2 : '',
                                EscalationLevel2Dt : '',
                                EscalationLevel3 : '',
                                EscalationLevel3Dt : '',
                                EscalationLevel4 : '',
                                EscalationLevel4Dt : '',
                                ReportingToEmpId1 : '',
                                ReportingToEmpId2 : '',
                                ReportingToEmpId3 : '',
                                Comments : visa.visaComments,
                                TicketNumber : '',
                                TicketPnr : '',
                                TicketAirline : '',
                                TicketFromAirport : '',
                                TicketToAirport : '',
                                TicketDateOfJourney : '',
                                ReturnTicketNumber : '',
                                ReturnTicketPnr : '',
                                ReturnTicketAirline : '',
                                ReturnTicketFromAirport : '',
                                ReturnTicketToAirport : '',
                                ReturnTicketDateOfJourney : '',
                                TicketCancelBeforeDate1 : '',
                                TicketCancelValueBeforeDate1 : '',
                                TicketCancelBeforeDate2 : '',
                                TicketCancelValueBeforeDate2 : '',
                                TicketCancelBeforeDate3 : '',
                                TicketCancelValueBeforeDate3 : '',
                                Exitreentryvisanumber : visa.EXITREENTRYVISANUMBER,
                                Exitreentryvisaissuedate : visa.EXITREENTRYVISAISSUEDATE,
                                Exitreentryvisaexpirydate : visa.EXITREENTRYVISAEXPIRYDATE,
                                Visitingcountryvisanumber : visa.VISITINGCOUNTRYVISANUMBER,
                                Visitingcountryissuedate : visa.VISITINGCOUNTRYISSUEDATE,
                                Visitingcountryexpirydate : visa.VISITINGCOUNTRYEXPIRYDATE,
                                Transportationdatetime : '',
                                Transportationfrom : '',
                                Transportationto : '',
                                CompanyId : this.props.loggedUserDetail.CompanyId,
                                Actionnum : visa.Actionnum,
                                Createdby : visa.Createdby,
                                Actiontype : visa.Actiontype,
                                Responsibledepartment : visa.Responsibledepartment,
                                AssignedTo : visa.AssignedTo,
                                Targetdate : visa.Targetdate,
                                StatusId : (visa.visaStatus===null) ? 1 : visa.visaStatus,
                                Actiondescription : visa.Actiondescription,
                            }   
                    })

                }
                if(this.state.transportActionDetails && this.state.transportActionDetails.length > 0){
                    actionData = this.state.transportActionDetails.map(transport => {
                        return{
                                Requestid : id,
                                Requestactionid:transport.requestactionid,
                                DeligateToEmployeeId : '',
                                DelicateToEmpEmailId : '',
                                DeligateFromDate : '',
                                DeligateToDate : '',                    
                                AssignedByEmployeeId : '',
                                Createddate : new Date(),
                                Updatedby : '',
                                Updateddate : '',
                                ApprovalPathId : '',
                                ApprovalPathSequence : '',
                                PreviousDate : '',
                                EscalationLevel1 : '',
                                EscalationLevel1Dt : '',
                                EscalationLevel2 : '',
                                EscalationLevel2Dt : '',
                                EscalationLevel3 : '',
                                EscalationLevel3Dt : '',
                                EscalationLevel4 : '',
                                EscalationLevel4Dt : '',
                                ReportingToEmpId1 : '',
                                ReportingToEmpId2 : '',
                                ReportingToEmpId3 : '',
                                Comments : transport.transportComments,
                                TicketNumber : '',
                                TicketPnr : '',
                                TicketAirline : '',
                                TicketFromAirport : '',
                                TicketToAirport : '',
                                TicketDateOfJourney : '',
                                ReturnTicketNumber : '',
                                ReturnTicketPnr : '',
                                ReturnTicketAirline : '',
                                ReturnTicketFromAirport : '',
                                ReturnTicketToAirport : '',
                                ReturnTicketDateOfJourney : '',
                                TicketCancelBeforeDate1 : '',
                                TicketCancelValueBeforeDate1 : '',
                                TicketCancelBeforeDate2 : '',
                                TicketCancelValueBeforeDate2 : '',
                                TicketCancelBeforeDate3 : '',
                                TicketCancelValueBeforeDate3 : '',
                                Exitreentryvisanumber : '',
                                Exitreentryvisaissuedate :  '',
                                Exitreentryvisaexpirydate :  '',
                                Visitingcountryvisanumber :  '',
                                Visitingcountryissuedate :  '',
                                Visitingcountryexpirydate : '',
                                Transportationdatetime : transport.TRANSPORTATIONDATETIME,
                                Transportationfrom : transport.TRANSPORTATIONFROM,
                                Transportationto : transport.TRANSPORTATIONTO,
                                CompanyId : this.props.loggedUserDetail.CompanyId,
                                Actionnum : transport.Actionnum,
                                Createdby : transport.Createdby,
                                Actiontype : transport.Actiontype,
                                Responsibledepartment : transport.Responsibledepartment,
                                AssignedTo : transport.AssignedTo,
                                Targetdate : transport.Targetdate,
                                StatusId : (transport.transportStatus===null) ? 1 : transport.transportStatus,
                                Actiondescription : transport.Actiondescription,
                            }   
                    })

                }

                if(this.state.iqamaActionDetails && this.state.iqamaActionDetails.length > 0){
                    actionData = this.state.iqamaActionDetails.map(iqama => {
                        return{
                                Requestid : id,
                                Requestactionid:iqama.requestactionid,
                                DeligateToEmployeeId : '',
                                DelicateToEmpEmailId : '',
                                DeligateFromDate : '',
                                DeligateToDate : '',                    
                                AssignedByEmployeeId : '',
                                Createddate : new Date(),
                                Updatedby : '',
                                Updateddate : '',
                                ApprovalPathId : '',
                                ApprovalPathSequence : '',
                                PreviousDate : '',
                                EscalationLevel1 : '',
                                EscalationLevel1Dt : '',
                                EscalationLevel2 : '',
                                EscalationLevel2Dt : '',
                                EscalationLevel3 : '',
                                EscalationLevel3Dt : '',
                                EscalationLevel4 : '',
                                EscalationLevel4Dt : '',
                                ReportingToEmpId1 : '',
                                ReportingToEmpId2 : '',
                                ReportingToEmpId3 : '',
                                Comments : iqama.iqamaComments,
                                TicketNumber : '',
                                TicketPnr : '',
                                TicketAirline : '',
                                TicketFromAirport : '',
                                TicketToAirport : '',
                                TicketDateOfJourney : '',
                                ReturnTicketNumber : '',
                                ReturnTicketPnr : '',
                                ReturnTicketAirline : '',
                                ReturnTicketFromAirport : '',
                                ReturnTicketToAirport : '',
                                ReturnTicketDateOfJourney : '',
                                TicketCancelBeforeDate1 : '',
                                TicketCancelValueBeforeDate1 : '',
                                TicketCancelBeforeDate2 : '',
                                TicketCancelValueBeforeDate2 : '',
                                TicketCancelBeforeDate3 : '',
                                TicketCancelValueBeforeDate3 : '',
                                Exitreentryvisanumber : '',
                                Exitreentryvisaissuedate :  '',
                                Exitreentryvisaexpirydate :  '',
                                Visitingcountryvisanumber :  '',
                                Visitingcountryissuedate :  '',
                                Visitingcountryexpirydate : '',
                                Transportationdatetime : '',
                                Transportationfrom : '',
                                Transportationto : '',
                                CompanyId : this.props.loggedUserDetail.CompanyId,
                                Actionnum : iqama.Actionnum,
                                Createdby : iqama.Createdby,
                                Actiontype : iqama.Actiontype,
                                Responsibledepartment : iqama.Responsibledepartment,
                                AssignedTo : iqama.AssignedTo,
                                Targetdate : iqama.Targetdate,
                                StatusId : (iqama.iqamaStatus===null) ? 1 : iqama.iqamaStatus,
                                Actiondescription : iqama.Actiondescription,
                            }   
                    })

                }
                data = {
                    Requestactions : actionData
                }
            }
            else if(type==='delegate'){
                if(this.state.Delegate_WF_Level_ID!==null){
                    data.Delegate_WF_Level_ID = this.state.Delegate_WF_Level_ID;
                }
            }
            else if(type==='forward'){
                if(this.state.Delegate_WF_Level_ID!==null){
                    data.Forward_WF_Level_ID = this.state.Delegate_WF_Level_ID;
                }
            }
            else if(type==='return'){
                if(this.state.Delegate_WF_Level_ID!==null){
                    data.Return_WF_Level_ID = this.state.Delegate_WF_Level_ID;
                }

                if(Return_WF_Level_ID!==''){
                    data.RETURN_TO_WF_LEVEL_ID = Return_WF_Level_ID;
                }
            }
            
            var dd = JSON.stringify(data);
            var datas = {Key : dd};
            let url = (this.state.type === 'edit') ? '/master/api/UpdateDynamicData?model='+model : '/master/api/InsertDynamicData?model='+model;
            
            if(type === 'submit'){
                url = '/master/api/workflow/submit?type='+model;
            }else if(type === 'reject'){
                url = '/master/api/workflow/Reject?type=LeaveRequest';
            }else if(type === 'cancel'){
                url = '/master/api/workflow/Cancel?type=LeaveRequest';
            }else if(type === 'delegate'){
                url = '/master/api/workflow/delegate?type=LeaveRequest';
            }else if(type === 'forward'){
                url = '/master/api/workflow/forward?type=LeaveRequest';
            }else if(type === 'return'){
                url = '/master/api/workflow/return?type=LeaveRequest';
            }
            
            axios.post(url, JSON.stringify(datas))
            .then(response =>{
                this.setState({loading:false});
                if(type === 'submit' || type === 'cancel' || type === 'reject' || type === 'delegate'  || type === 'return'){
                    if(response.status === 200){ 
                        if(response.data.id!==undefined && response.data.id ==='DYNAMIC'){
                            let submitValue = JSON.parse(response.data.result);
                            let tableValue = [];
                            if(submitValue.Table !==undefined && submitValue.Table.length > 0){
                                tableValue = submitValue.Table.map(list=>{
                                    let Request_WF_LEVEL_ID = list.EMPLOYEE_ID;
                                    if(list.Request_WF_LEVEL_ID!==undefined){
                                        Request_WF_LEVEL_ID = list.Request_WF_LEVEL_ID
                                    }
                                    return {label : list.NAME, value : list.EMPLOYEE_ID, id : list.EMPLOYEE_NO, Request_WF_LEVEL_ID : list.Request_WF_LEVEL_ID}
                                })
                            }
                            this.setState({dynamicSupervisorDisplay:true,DynamicSupervisorsList:tableValue,DynamicRequestID:response.data.requestId})
                        } else {
                        
                            localStorage.removeItem(`Request/GetRequest?id=${this.props.loggedUserDetail.empID}&processid=${LEAVE_REQUEST_ID}`);
                         
                            this.growl.show({ severity: 'success', summary: null, detail: 'Request Submitted Successfully' });
                            setTimeout(()=>{
                                if(redirect !==''){
                                    this.props.history.push(redirect);
                                }else{
                                    this.props.history.push('/leave-request-list');
                                }
                                
                            },2000)
                        }
                        

                    }else{
                        this.growl.show({severity: 'error', summary: null, detail: 'Failed'});
                    }

                }else if(type === 'actionSubmit'){
                    if(response.status === 200){ 
                        this.growl.show({severity: 'success', summary: null, detail: 'Action submitted successfully'});
                        setTimeout(()=>{
                            if(redirect !==''){
                                this.props.history.push(redirect);
                            }
                        },2000)
                    }else{
                        this.growl.show({severity: 'error', summary: null, detail: 'Failed'});
                    }
                    
                }else{
                    if (response.data.statusCode === 1) {  
               
                            localStorage.removeItem(`Request/GetRequest?id=${this.props.loggedUserDetail.empID}&processid=${LEAVE_REQUEST_ID}`);
                     
                        this.growl.show({severity: 'success', summary: null, detail: response.data.message});
                        setTimeout(()=>{
                            this.props.history.push('/leave-request-list');
                        },2000)
                    }else{
                        this.growl.show({severity: 'error', summary: null, detail: 'Failed'});
                    }

                }
               
            })
            .catch(err => {
                this.setState({loading:false})
                this.growl.show({severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed'});
            }) 



        }
         

    }


    componentDidMount() { 
        //window.location.reload(true);
        let type = this.props.match.params.type;  
        let { requestactionid, id, sno, actionType }  = this.state;
        
        // if ((actionType == undefined || actionType == '' || actionType == null)) {
        //     var search = window.location.pathname;
        // }
        // else
        // {
            var search = window.location.search;
        // }
        if (search == "")
        {
            search =   window.location.pathname;
        }
        let params = new URLSearchParams(search);
        if (sno == undefined || sno == '' || sno == null) {
            sno = params.get('sno');
        }
        if (actionType == undefined || actionType == '' || actionType == null) {
            actionType = params.get('type');
        }
        if (requestactionid == undefined || requestactionid == '' || requestactionid == null) {
            requestactionid = params.get('Actionid');
        }
        let workflowID = params.get('levelid');

        const stageSequence = (this.props.location.state && this.props.location.state.stagesequence) || this.state.currentStage;
        this.setState({currentStage : stageSequence});
        
        if(sno!==undefined && sno !=='' && sno !==null){
            sno = DECRYPT(sno);
            this.setState({currentStage : parseInt(sno)});
        }

        if(actionType!==undefined && actionType !==''  && actionType !==null){
            actionType = DECRYPT(actionType);
            this.setState({actionType :  actionType});
        }

        if(requestactionid!==undefined && requestactionid !=='' && requestactionid !==null){
            requestactionid = DECRYPT(requestactionid);
            this.setState({requestactionid : requestactionid});
        }

        if(workflowID!==undefined && workflowID !=='' && workflowID !==null){
            workflowID = DECRYPT(workflowID);
            this.setState({Delegate_WF_Level_ID : workflowID});
        }


        this.props.getMasterKeywordList('Employee');
        const hrTeam = parseInt(localStorage.getItem('hrTeam'));
        this.props.getMasterKeywordList('relationType'); 
        if(!hrTeam){
            if(this.props.loggedUserDetail.empID !== undefined){
                let notHrTeam = this.props.fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId);
            }
        }
           


        setTimeout(()=> {
            this.props.getMasterKeywordList('TimeoffType');  
        }, 1000);
        setTimeout(()=> {
            this.props.getMasterKeywordList('City');  
        }, 2000);


        setTimeout(()=> {
            this.props.getMasterKeywordList('OrgUnit');
        }, 5000);


        setTimeout(()=> {
            this.props.getMasterKeywordList('ActionStatus');
        }, 4000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('ActionType');
        }, 2000);
       

        if(type !== 'add'){
            this.setState({loading:true});
            setTimeout(()=>{
                this.setState({loading:false});
                this.fetchSingleProcess();
            },3000)
        }

    //    this.setState({reqStatus:this.props.tableLists.status})

    }


    fetchSingleProcess = () =>{
        // let id = this.props.match.params.id.replace('?', '&');  ***
        let id = this.props.match.params.id;   
        localStorage.removeItem('Employee/RequestAttributesDetails?Id='+id);
        this.props.getMasterTableList('Employee/RequestAttributesDetails?Id='+id);   
    }


    addAttachmentContainer = (e, index,field,fieldLength, attachmentCounts) => {
        e.preventDefault();
        this.setState({loading:true});
        let file = e.target.files[0];
        let name= 'LeaveRequest_Attachments_'+UPLOAD_NAME_CONCAT+'_'+file.name;
        const frmData = new FormData();
        frmData.append('file', file,  name );
        return axios.post('/master/api/upload?FolderName=LeaveRequestAttachments', frmData ).then(response =>{

            let fileExtension = response.data.fileExtention;
            let fileName = response.data.fileName;
            let filePath = response.data.filePath;
            this.setState({loading:false,fileExtension:fileExtension,filePath:filePath,fileName:fileName,hasAttachment:true});

            setTimeout(()=> {
                this.addFormContanier(e,index,field,fieldLength,attachmentCounts);
            },1000)

        })
        .catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'File Upload Failed'});
            this.setState({loading:false});
        })  
    }

    addAttachmentData = (e, data,field,fieldLength, attachmentCounts, ) => {
        e.preventDefault();
        this.setState({loading:true});
        let file = e.target.files[0];
        if(!file){
            this.setState({loading:false});
            return;
        }
        let name= 'LeaveRequest_Attachments_'+UPLOAD_NAME_CONCAT+'_'+file.name;
        const frmData = new FormData();
        frmData.append('file', file,  name );

        return axios.post('/master/api/upload?FolderName=LeaveRequestAttachments', frmData ).then(response =>{

            let fileExtension = response.data.fileExtention;
            let fileName = response.data.fileName;
            let filePath = response.data.filePath;
            let virtualFilePath = response.data.virtualFilePath;
            let folderName = 'LeaveRequestAttachments';
            this.setState({ loading: false,hasAttachment:true, attachmentData: this.state.attachmentData.concat(Object.assign({}, { fileExtension: fileExtension, filePath: filePath, fileName: fileName, virtualFilePath, folderName })) });

            // setTimeout(()=> {
            //     this.addFormContanier(e,index,field,fieldLength,attachmentCounts);
            // },1000)

        })
        .catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'File Upload Failed'});
            this.setState({loading:false});
        })
    }

    getNextWorkingDate = (toDate) => {
        this.setState({loading:true});
        const { requestedFor, fromDate,timeoffTypeId } = this.state;
        const reportingDate = moment(toDate).add(1, 'days');
        axios.get(`/master/api/GetNextWorkingDate?id=${requestedFor}&tt=${timeoffTypeId}&FromDate=${moment(fromDate).format('MM/DD/YYYY')}&ReportingDate=${moment(reportingDate).format('MM/DD/YYYY')}`).then(response =>{
            this.setState({loading:false});
            return response.data.nextWorkingDate
        }).catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'Next Working Date API Failed'});
            this.setState({loading:false});
        })  
    }



    addFormContanier = (e, index,field,fieldLength, formCounts) => {
        e.preventDefault();
   
        let dateFormat = this.props.userPref.dateFormat;
        let fieldName = 'field_'+field;
        let copyStages = [...this.state.stages];
        let indexStage = copyStages[index];
        let stageField = indexStage.stageFields;
        let selectedField = stageField[fieldName];
        let selectedContainer = selectedField.ContainerFields;
    
        if(selectedContainer && formCounts === 0){
            let defaultContainers = selectedContainer[selectedContainer.length-1];
            var keys = Object.keys(defaultContainers);
       
            for(let i = 0; i < keys.length;i++){

                let fieldDynamicValue = '';    
                if(defaultContainers[keys[i]].FieldLabel === 'Selected Form'){fieldDynamicValue = this.state.selectedForm}
                else if(defaultContainers[keys[i]].FieldLabel === 'Selected Person'){fieldDynamicValue = this.state.sendToWho}
                else if(defaultContainers[keys[i]].FieldLabel === 'Target Date'){fieldDynamicValue = this.state.targetDate}
                else if(defaultContainers[keys[i]].FieldLabel === 'File Name'){fieldDynamicValue = this.state.fileName}
                else if(defaultContainers[keys[i]].FieldLabel === 'File Extension'){fieldDynamicValue = this.state.fileExtension}
                else if(defaultContainers[keys[i]].FieldLabel === 'File Path'){fieldDynamicValue = this.state.filePath}

                else if(defaultContainers[keys[i]].FieldLabel === 'Created By'){fieldDynamicValue = this.props.loggedUserDetail.empID}
                else if(defaultContainers[keys[i]].FieldLabel === 'Action Type'){fieldDynamicValue = this.state.selectedAction}
                else if(defaultContainers[keys[i]].FieldLabel === 'Department Name'){fieldDynamicValue = this.state.selectedDepartment}
                else if(defaultContainers[keys[i]].FieldLabel === 'Assigned To'){fieldDynamicValue = this.state.selectedPerson}
                else if(defaultContainers[keys[i]].FieldLabel === 'Action Description'){fieldDynamicValue = this.state.actionComments}
                else if(defaultContainers[keys[i]].FieldLabel === 'Action Target Date'){fieldDynamicValue = this.state.selectedTargetDate}
                else if(defaultContainers[keys[i]].FieldLabel === 'Status'){fieldDynamicValue = this.state.actionStatus}
                

                defaultContainers[keys[i]] = {
                    FieldName   : removeString(defaultContainers[keys[i]].FieldName),
                    FieldLabel  : defaultContainers[keys[i]].FieldLabel,
                    FieldValue  : fieldDynamicValue,
                    FieldType   : defaultContainers[keys[i]].FieldType,
                    DataType    : defaultContainers[keys[i]].DataType,
                    ParentFieldId: defaultContainers[keys[i]].ParentFieldId,
                    ChildRowNmbr: defaultContainers[keys[i]].ChildRowNmbr,
                    type : defaultContainers[keys[i]].type,
                    ContainerFields : null,
                    //FieldId : defaultContainers[keys[i]].FieldId,
                };
            }
            selectedContainer[selectedContainer.length-1] = defaultContainers;
            selectedField['ContainerFields'] = selectedContainer;
            stageField[fieldName] = selectedField;
            indexStage['stageFields'] = stageField;
            copyStages[index] = indexStage;
            this.setState({stages: copyStages,selectedForm:'',sendToWho:'',targetDate:'',selectedAction:'',selectedDepartment:'',selectedPerson:'',selectedTargetDate:'',actionComments:'',actionStatus:'',loadOnce:false});
        }else{

            let incrementRow = selectedContainer.length + 1;
            let totalFields = fieldLength;
            let lastFieldName = Object.keys(selectedContainer[selectedContainer.length-1])[totalFields-1];
            let lastFieldId = removeString(lastFieldName)
            

            let defaultContainers = selectedContainer[0];
            var keys = Object.keys(defaultContainers);
    
            let newValue = [];
            
            
            for(let i = 1; i <= totalFields;i++){
                let flReference = selectedContainer[0][keys[i-1]];
              

                let fieldDynamicValue = '';    
                if(flReference.FieldLabel === 'Selected Form'){fieldDynamicValue = this.state.selectedForm}
                else if(flReference.FieldLabel === 'Selected Person'){fieldDynamicValue = this.state.sendToWho}
                else if(flReference.FieldLabel === 'Target Date'){fieldDynamicValue = this.state.targetDate}
                else if(flReference.FieldLabel === 'File Name'){fieldDynamicValue = this.state.fileName}
                else if(flReference.FieldLabel === 'File Extension'){fieldDynamicValue = this.state.fileExtension}
                else if(flReference.FieldLabel === 'File Path'){fieldDynamicValue = this.state.filePath}

                else if(flReference.FieldLabel === 'Created By'){fieldDynamicValue = this.props.loggedUserDetail.empID}
                else if(flReference.FieldLabel === 'Action Type'){fieldDynamicValue = this.state.selectedAction}
                else if(flReference.FieldLabel === 'Department Name'){fieldDynamicValue = this.state.selectedDepartment}
                else if(flReference.FieldLabel === 'Assigned To'){fieldDynamicValue = this.state.selectedPerson}
                else if(flReference.FieldLabel === 'Action Description'){fieldDynamicValue = this.state.actionComments}
                else if(flReference.FieldLabel === 'Action Target Date'){fieldDynamicValue = this.state.selectedTargetDate}
                else if(flReference.FieldLabel === 'Status'){fieldDynamicValue = this.state.actionStatus}

                let inc = parseInt(lastFieldId)+parseInt(i);
                newValue['field_00'+inc]= {
                    FieldName :  '00'+inc,
                    FieldValue : fieldDynamicValue,
                    ChildRowNmbr : incrementRow,
                    FieldLabel : flReference.FieldLabel,
                    DataType : flReference.DataType,
                    FieldType : flReference.FieldType,
                    ParentFieldId: flReference.ParentFieldId,
                    type : flReference.type
                };
            }

            let depContainers = [...selectedContainer, {...newValue}];
            selectedField['ContainerFields'] = depContainers;
            stageField[fieldName] = selectedField;
            indexStage['stageFields'] = stageField;
            copyStages[index] = indexStage;
            this.setState({stages:copyStages,selectedForm:'',sendToWho:'',targetDate:'',selectedAction:'',selectedDepartment:'',selectedPerson:'',selectedTargetDate:'',actionComments:'', actionStatus: '',loadOnce:false});
        }
    }

    addContainerField = (index, depIndex, field, fieldArray) => {
        let fieldName = 'field_'+field;
        let copyStages = [...this.state.stages];
        let indexStage = copyStages[index];
        let stageField = indexStage.stageFields;
        let selectedField = stageField[fieldName];
        let selectedContainer = selectedField.ContainerFields;


        let incrementRow = selectedContainer.length + 1;
        let totalFields = fieldArray.length;
        let lastFieldName = Object.keys(selectedContainer[selectedContainer.length-1])[totalFields-1];
        let lastFieldId = removeString(lastFieldName)

        let newValue = [];
        for(let i = 1; i <= totalFields;i++){
            let flReference = selectedContainer[0][fieldArray[i-1]];

            let fieldDynamicValue ='';

            if(flReference.FieldLabel === 'Gender'){fieldDynamicValue = 'Male';}
            else if(flReference.FieldLabel === 'Ticket classification'){fieldDynamicValue = 'One Way';}
            else if(flReference.FieldLabel === 'Present Location'){fieldDynamicValue = 'In KSA';}

            let inc = parseInt(lastFieldId)+parseInt(i);
            newValue['field_00'+inc]= {
                FieldName :  '00'+inc,
                FieldValue : fieldDynamicValue,
                ChildRowNmbr : incrementRow,
                FieldLabel : flReference.FieldLabel,
                DataType : flReference.DataType,
                FieldType : flReference.FieldType,
                ParentFieldId: flReference.ParentFieldId,
                type : flReference.type
            };
        }
        let depContainers = [...selectedContainer, {...newValue}];
        selectedField['ContainerFields'] = depContainers;
        stageField[fieldName] = selectedField;
        indexStage['stageFields'] = stageField;
        copyStages[index] = indexStage;
        this.setState({stages:copyStages});
    }


    gridFormsTemplate = (rowData, index, fields) => {
        return <div className="actionCenter">
                    <Button  className="p-button-danger" onClick={() => this.removeFormContainerField(index, rowData.key, fields)} icon="pi pi-trash"  />
        </div>;
    }

    deleteAttachmentTemplate = (rowData, index, fields) => {
        return <div className="actionCenter">
            <Button className="p-button-danger" icon="pi pi-trash" onClick={() => this.handleDeleteTemplate(rowData)} />
        </div>;
    }

    downloadTemplate = (rowData) => {
        return <div className="actionCenter">
            <Button type="button" icon="pi pi-download" onClick = {() =>this.downloadAttachmentData(rowData)}  className="p-button-info" ></Button>
        </div>;
    }

    handleDeleteTemplate(rowData) {
        let newAttachmentData = this.state.attachmentData.filter(_ => _.fileName != rowData.fileName);
        this.setState({ attachmentData: newAttachmentData })
    }

    downloadAttachmentData = (rowData) => {

        this.setState({loading:true});
        let extension = rowData.fileExtension;
        let fileName = rowData.fileName;

        axios({
            url: `/master/api/Download?filename=${rowData.fileName}&&FolderName=LeaveRequestAttachments&&ext=${rowData.fileExtension}`,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName + extension}`);
            document.body.appendChild(link);
            link.click();
            this.setState({loading: false})
          }).catch((err) => {
            this.growl.show({ severity: 'error', summary: 'null', detail: 'File Download failed, please try again.' });
          })
    }

    reloadAttachmentData(data) {
        let folderName = 'LeaveRequestAttachments';
        let attachments = data.map(el => {
            return{
                fileExtension: el.extension, 
                filePath: el.uploadPath, 
                fileName: el.fileName, 
                folderName 
            }
        })
        this.setState({attachmentData:attachments})
    }

    removeFormContainerField = (index, depIndex, field) => {
        let fieldName = 'field_'+field;
        let copyStages = [...this.state.stages];
        let indexStage = copyStages[index];
        let stageField = indexStage.stageFields;
        let selectedField = stageField[fieldName];
        let selectedContainer = selectedField.ContainerFields;


        if(selectedContainer.length > 1){
            let depContainers = selectedContainer.filter((list,ind) => {
                return ind!==depIndex
            });
            selectedField['ContainerFields'] = depContainers;
            stageField[fieldName] = selectedField;
            indexStage['stageFields'] = stageField;
            copyStages[index] = indexStage;
            this.setState({stages:copyStages});
        }else{
            let defaultContainers = selectedContainer[selectedContainer.length-1];
            var keys = Object.keys(defaultContainers);
            for(let i = 0; i < keys.length;i++){
                defaultContainers[keys[i]] = {
                    FieldName   : removeString(defaultContainers[keys[i]].FieldName),
                    FieldLabel  : defaultContainers[keys[i]].FieldLabel,
                    FieldValue  : '',
                    FieldType   : defaultContainers[keys[i]].FieldType,
                    DataType    : defaultContainers[keys[i]].DataType,
                    ParentFieldId: defaultContainers[keys[i]].ParentFieldId,
                    ChildRowNmbr: defaultContainers[keys[i]].ChildRowNmbr,
                    type : defaultContainers[keys[i]].type,
                    ContainerFields : null,
                };
            }
            selectedContainer[selectedContainer.length-1] = defaultContainers;
            selectedField['ContainerFields'] = selectedContainer;
            stageField[fieldName] = selectedField;
            indexStage['stageFields'] = stageField;
            copyStages[index] = indexStage;
            this.setState({stages: copyStages});
        }
    }

    removeContainerField = (index, depIndex, field) => {
        let fieldName = 'field_'+field;
        let copyStages = [...this.state.stages];
        let indexStage = copyStages[index];
        let stageField = indexStage.stageFields;
        let selectedField = stageField[fieldName];
        let selectedContainer = selectedField.ContainerFields;
        let depContainers = selectedContainer.filter((list,ind) => {
            return ind!==depIndex
        });
        selectedField['ContainerFields'] = depContainers;
        stageField[fieldName] = selectedField;
        indexStage['stageFields'] = stageField;
        copyStages[index] = indexStage;
        this.setState({stages:copyStages});
    }

    updateDependentDetails = (e, Index, depIndex, FieldLabel, FieldType, DataType ,ParentFieldId, ChildRowNmbr, field) => {
        let { name, value } = e.target;
    

        if(value !== null){
            let fieldName = 'field_'+field;
            let copyStages = [...this.state.stages];
            let indexStage = copyStages[Index];
            let stageField = indexStage.stageFields;
            let selectedField = stageField[fieldName];
            let selectedContainer = selectedField.ContainerFields;
            let flName = 'field_'+name;
    
            let dependentDetails = {}
            if(this.props.dependentDetails && this.props.dependentDetails.length > 0){
                dependentDetails = this.props.dependentDetails.filter(list => {
                    return value === list.depandentID
                }).reduce((_,el)=>{
                    return el;
                },{})
            }

            let depContainers = selectedContainer[depIndex];


            

            let dName = 'field_00'+(name-10);
            let dType = 'field_00'+(name-9);
            let dAge= 'field_00'+(name-8);
            let dGender = 'field_00'+(name-7);
            let gender = 'Male';
            if(parseInt(dependentDetails.gender) == 2){
                gender = 'Female';
            }
            

            var myArray = {
                [dName] : {
                    value : dependentDetails.name,
                    FieldLabel : 'Dependent name',
                    FieldType : 1,
                    DataType : 'string'
                }, 
                [dAge] : {
                    value : dependentDetails.age,
                    FieldLabel : 'Gender',
                    FieldType : 1,
                    DataType : 'string'
                }, 
                [dGender] : {
                    value : gender,
                    FieldLabel : 'Age',
                    FieldType : 1,
                    DataType : 'string'
                },
                [dType] : {
                    value : parseInt(dependentDetails.relationType),
                    FieldLabel : 'Dependent Relation',
                    FieldType : 1,
                    DataType : 'string'
                }
            };

            for (var key in myArray) {


                let FieldId = '';
                if(depContainers[key].FieldId !==undefined || depContainers[key].FieldId !==''){
                    FieldId = depContainers[key].FieldId;
                }

                depContainers[key] = {
                    FieldName   : removeString(key),
                    FieldLabel  : myArray[key].FieldLabel,
                    FieldValue  : myArray[key].value,
                    FieldType   : myArray[key].FieldType,
                    DataType    : myArray[key].DataType,
                    ParentFieldId: ParentFieldId,
                    ChildRowNmbr: ChildRowNmbr,
                    type : stageField[fieldName].type,
                    ContainerFields : null,
                };
                
                if(FieldId !== '' && FieldId!==undefined){
                    depContainers[key]['FieldId'] = FieldId;
                }

            }
    
    
            selectedContainer[depIndex] = depContainers;
            selectedField['ContainerFields'] = selectedContainer;
            stageField[fieldName] = selectedField;
            indexStage['stageFields'] = stageField;
            copyStages[Index] = indexStage;
            this.setState({stages:copyStages});
        }

    }

    updateContainerDetails = (e, Index, depIndex, FieldLabel, FieldType, DataType ,ParentFieldId, ChildRowNmbr, field) => {
        let dateFormat = this.props.userPref.dateFormat;
        let { name, value } = e.target;
        if(FieldType === 'calendar'){
            value =  DateFormetter(value, dateFormat);
        }
        let fieldName = 'field_'+field;
        let copyStages = [...this.state.stages];
        let indexStage = copyStages[Index];
        let stageField = indexStage.stageFields;
        let selectedField = stageField[fieldName];
        let selectedContainer = selectedField.ContainerFields;

        let flName = 'field_'+name;

        let depContainers = selectedContainer[depIndex];


        let FieldId = '';

        if(depContainers[flName].FieldId !==undefined || depContainers[flName].FieldId !==''){
            FieldId = depContainers[flName].FieldId;
        }


        depContainers[flName] = {
            FieldName   : removeString(name),
            FieldLabel  : FieldLabel,
            FieldValue  : value,
            FieldType   : FieldType,
            DataType    : DataType,
            ParentFieldId: ParentFieldId,
            ChildRowNmbr: ChildRowNmbr,
            type : stageField[fieldName].type,
            ContainerFields : null,
            //FieldId : stageField[fieldName].FieldId,
        };
        if(FieldId !== '' && FieldId!==undefined){
            depContainers[flName]['FieldId'] = FieldId;
        }

        

        selectedContainer[depIndex] = depContainers;

        selectedField['ContainerFields'] = selectedContainer;
        stageField[fieldName] = selectedField;
        indexStage['stageFields'] = stageField;
        copyStages[Index] = indexStage;
        this.setState({stages:copyStages});
    }


    checkAllotment = () => {
        this.setState({allowButton : true});
        let copyStages = [...this.state.stages];
        let indexStage = copyStages[0];
        let stageField = indexStage.stageFields;

        let empID = stageField['field_001001000001'].FieldValue;
        let leaveID = stageField['field_001001000003'].FieldValue;
        if(empID!==null & leaveID!==null){
            let quotaID ='';
            if(this.props.TimeoffType && this.props.TimeoffType.length > 0){
                quotaID = this.props.TimeoffType.filter((type)=>{
                    return type.value === leaveID
                }).reduce((_, el) => {
                    return el.quotaType;
                },'');
            }

            let allocatedDays = 0;
            let usedDays = 0;
            let quotaData = {};
            if(quotaID!==''){
                if(this.props.quotaDetails && this.props.quotaDetails.length > 0){
                    quotaData = this.props.quotaDetails.filter((type)=>{
                        return type.quotatypeId === quotaID
                    }).reduce((_, el) => {
                        return el;
                    },{});
                }
            }

            if(quotaData.allocatedDays!==undefined){
                allocatedDays = quotaData.allocatedDays;
                usedDays = quotaData.usedDays;
            }

            let fromDate = stageField['field_001001000004'].FieldValue;
            let toDate = stageField['field_001001000005'].FieldValue;

            if(fromDate!=='' && toDate!==''){

                var admission = moment(fromDate, 'DD-MM-YYYY'); 
                var discharge = moment(toDate, 'DD-MM-YYYY');
                let days = discharge.diff(admission, 'days');
                days = days+1;

                let calculateDays = allocatedDays - usedDays - days;

                

                if(calculateDays <= 0 && this.state.currentStage === 0 && this.state.type==='add'){
                    this.growl.show({severity: 'error', summary: null, detail: 'You do not have leave allocation. Contact your manager.'});
                    this.setState({allowButton : false});
                }

            }



        }


       

    }

    changeActions = (e,index,type) => {
        let { name, value } = e.target;
      
        if(type === 'ticket'){
            let copyValues = [...this.state.ticketActionDetails];
            let indexPlace = copyValues[index];
            indexPlace[name] = value;
            copyValues[index] = indexPlace;
            this.setState({ticketActionDetails:copyValues});
        }
        else if(type === 'visa'){
            let copyValues = [...this.state.visaActionDetails];
            let indexPlace = copyValues[index];
            indexPlace[name] = value;
            copyValues[index] = indexPlace;
            this.setState({visaActionDetails:copyValues});
        }
        else if(type === 'transport'){
            let copyValues = [...this.state.transportActionDetails];
            let indexPlace = copyValues[index];
            indexPlace[name] = value;
            copyValues[index] = indexPlace;
            this.setState({transportActionDetails:copyValues});
        }
        else if(type === 'iqama'){
            let copyValues = [...this.state.iqamaActionDetails];
            let indexPlace = copyValues[index];
            indexPlace[name] = value;
            copyValues[index] = indexPlace;
            this.setState({iqamaActionDetails:copyValues});
        }
    }
    
    findNationality = (z) => {// z is the selected value of requested for
        let  a = (this.props.loggedUserDetail!==null) ? [{label: `${this.props.loggedUserDetail.userName}(Self)`, value: this.props.loggedUserDetail.empID, id: this.props.loggedUserDetail.userID, nationality: this.props.loggedUserDetail.nationality}].concat(this.props.subordinatesListData) : this.props.subordinatesListData; // concatenating requested for and subordinates to create an iterable array with country       

        const isSaudi = a.filter((a) => {//filtering through subordinates list
            return a.value == z
        }).map(a => {//whether the person is Saudi or not
            return a.nationality == 'SA'
        })
        this.setState({requestedForIsSaudi: isSaudi[0]})
        return isSaudi[0]//returning if a person is saudi or not
        

    }
    

    updateChangeDetails = (e, Index, FieldLabel, FieldType, DataType ,ParentFieldId, ChildRowNmbr) => {
        if(FieldLabel === 'Request For'){
            this.setState({ requestedFor: e.target.value });
        }
        let dateFormat = this.props.userPref.dateFormat;
        let { name, value } = e.target;
        let z = value
        
        
        if(name === 'field_001001000001'){
            this.findNationality(z)
        }

        if(name === 'field_001001000001'){
            this.props.getTimeOffData({id: value});
        }

        if(name === 'field_001001000003'){
            this.setState({timeoffTypeId: value});
        }

        if(name === 'field_001001000034'){
            this.setState({ticketRequired: value})
        }

        // if(name === 'field_001001000038'){
        //     this.setState({hasAcknowledged: value})
        // }
    
        if(FieldType === 'calendar'){
            value =  DateFormetter(value, dateFormat);
        }

        let copyStages = [...this.state.stages];
        let indexStage = copyStages[Index];
        let stageField = indexStage.stageFields;
       
        if(name === 'field_001001000006' && value === true){

            let startDate = '';
            if(stageField['field_001001000004'].FieldValue!==''){
                startDate = new Date(stageField['field_001001000004'].FieldValue).getTime();
            }
            let endDate = '';
            if(stageField['field_001001000005'].FieldValue!==''){
                endDate = new Date(stageField['field_001001000005'].FieldValue).getTime();
            }

            if(startDate === '' || endDate === ''){
                this.growl.show({severity: 'error', summary: null, detail: 'Start Date and End Date should not be empty'});
                return;
            }else if(startDate !== endDate){
                this.growl.show({severity: 'error', summary: null, detail: 'Start Date and End Date should be the same for half day leave'});
                return;
            }
        }
      
        if(name === 'field_001001000001' && value!==null){
            this.props.getDependentDetails(value);
            this.props.getQuotaDetails(value);
        }

        // this.checkAllotment();
        
        let FieldId = '';
        if(stageField[name].FieldId !=='' || stageField[name].FieldId !==undefined){
            FieldId = stageField[name].FieldId;
        }
        stageField[name] = {
            FieldName   : removeString(name),
            FieldLabel  : FieldLabel,
            FieldValue  : value,
            FieldType   : FieldType,
            DataType    : DataType,
            ParentFieldId: ParentFieldId,
            ChildRowNmbr: ChildRowNmbr,
            type : stageField[name].type,
            ContainerFields : stageField[name].ContainerFields,
        };

        if(FieldId !== '' && FieldId!==undefined){
            stageField[name]['FieldId'] = FieldId;
        }

     
        if(name==='field_001001000004'){
            if(this.state.requestedFor == false || this.state.requestedFor == null || this.state.requestedFor == undefined){
                this.growl.show({severity: 'error', summary: null, detail: 'Select Requested For Before Selecting Starting date'});
                return;
            } else {
                this.setState({minDate:value,fromDate:value});
                setTimeout((el) => {
                    if( name === 'field_001001000004' || name ==='field_001001000005'){
                        if(this.state.fromDate !== '' && this.state.toDate !== ''){
                            let fromDate = moment(this.state.fromDate).format('MM/DD/YYYY');
                            let toDate = moment(this.state.toDate).format('MM/DD/YYYY');
                            let requestedFor = this.state.requestedFor;
                            let timeoffTypeId = this.state.timeoffTypeId;
                            let ProcessValidation = {};
                            ProcessValidation = {
                                EmployeeID : requestedFor,
                                FromDate: fromDate,
                                ToDate: toDate,
                                CompanyID : timeoffTypeId,
                                Type : timeoffTypeId.toString(),
                                RequestDate: fromDate,
                                TimeOffTypeId : timeoffTypeId,
                                RequestID : timeoffTypeId,
                                RequestedFor : requestedFor,
                                RequestType : timeoffTypeId,
                                ProcessID : timeoffTypeId,
                            };

                            let dd = JSON.stringify(ProcessValidation);
                            let  datas = {Key : dd};

                            this.setState({loading: true});
                            axios.post('/master/api/GetDays', JSON.stringify(datas))
                            .then((response) => {
                                if(response.status == 200){

                                    let noOfDays = response.data.statusCode;

                                    // to update number of leave days
                                    let FieldId4 = '';
                                    if(stageField['field_001001000037'].FieldId !=='' || stageField['field_001001000037'].FieldId !==undefined){
                                        FieldId4 = stageField['field_001001000037'].FieldId;
                                    }

                                    stageField['field_001001000037'] = {
                                        FieldName   : removeString('field_001001000037'),
                                        FieldLabel  : stageField['field_001001000037'].FieldLabel,
                                        FieldValue  : noOfDays,
                                        FieldType   : stageField['field_001001000037'].FieldType,
                                        DataType    : stageField['field_001001000037'].DataType,
                                        ParentFieldId: stageField['field_001001000037'].ParentFieldId,
                                        ChildRowNmbr: stageField['field_001001000037'].ChildRowNmbr,
                                        type : stageField['field_001001000037'].type,
                                        ContainerFields : stageField['field_001001000037'].ContainerFields,
                                    };
                                    if(FieldId4 !== '' && FieldId4!==undefined){
                                        stageField['field_001001000037']['FieldId'] = FieldId4;
                                    }
                                    
                                    this.setState({loading: false});
                                }
                            }).catch((error) => {
                                this.growl.show({severity: 'error', summary: null, detail: 'Number of Leave Days API Failed'});
                                this.setState({loading: false});
                            })
                        }                        
                    }
                }, 500)
            }
        }else if(name==='field_001001000005'){
            if(this.state.requestedFor == false || this.state.requestedFor == null || this.state.requestedFor == undefined){
                this.growl.show({severity: 'error', summary: null, detail: 'Select Requested For Before Selecting Ending date'});
                return;
            }
            this.setState({toDate:value});
            this.setState({ loading: true });
            const { requestedFor, fromDate, timeoffTypeId } = this.state;
            
            
                const reportingDate = moment(e.target.value).add(1, 'days');
                axios.get(`/master/api/GetNextWorkingDate?id=${ requestedFor}&tt=${ timeoffTypeId}&FromDate=${moment(fromDate).format('MM/DD/YYYY')}&ReportingDate=${moment(reportingDate).format('MM/DD/YYYY')}`)
                .then(response =>{


                    

                    // for reporting to date assigning from api
                    let FieldId2 = '';

                    if(stageField['field_001001000007'].FieldId !=='' || stageField['field_001001000007'].FieldId !==undefined){
                        FieldId2 = stageField['field_001001000007'].FieldId;
                    }
                
                    // var addOneMoreDay = response.data.nextWorkingDate
                    // addOneMoreDay.setDate(addOneMoreDay.getDate() + 1)

                    stageField['field_001001000007'] = {
                        FieldName   : removeString('field_001001000007'),
                        FieldLabel  : stageField['field_001001000007'].FieldLabel,
                        FieldValue  : new Date(response.data.nextWorkingDate),
                        FieldType   : stageField['field_001001000007'].FieldType,
                        DataType    : stageField['field_001001000007'].DataType,
                        ParentFieldId: stageField['field_001001000007'].ParentFieldId,
                        ChildRowNmbr: stageField['field_001001000007'].ChildRowNmbr,
                        type : stageField['field_001001000007'].type,
                        ContainerFields : stageField['field_001001000007'].ContainerFields
                    };
                    if(FieldId2 !== '' && FieldId2!==undefined){
                        stageField['field_001001000007']['FieldId'] = FieldId2;
                    }

                    //for ticket-from date assigining from api
                    let FieldId3 = '';
                    if(stageField['field_001001000017'].FieldId !=='' || stageField['field_001001000017'].FieldId !==undefined){
                        FieldId3 = stageField['field_001001000017'].FieldId;
                    }

                    stageField['field_001001000017'] = {
                        FieldName   : removeString('field_001001000017'),
                        FieldLabel  : stageField['field_001001000017'].FieldLabel,
                        FieldValue  : new Date(response.data.fromWorkingDate),
                        FieldType   : stageField['field_001001000017'].FieldType,
                        DataType    : stageField['field_001001000017'].DataType,
                        ParentFieldId: stageField['field_001001000017'].ParentFieldId,
                        ChildRowNmbr: stageField['field_001001000017'].ChildRowNmbr,
                        type : stageField['field_001001000017'].type,
                        ContainerFields : stageField['field_001001000017'].ContainerFields,
                    };
                    if(FieldId3 !== '' && FieldId3!==undefined){
                        stageField['field_001001000017']['FieldId'] = FieldId3;
                    }


                    // for ticket-to date assigning from api
                    let FieldId1 = '';
                    if(stageField['field_001001000018'].FieldId !=='' || stageField['field_001001000018'].FieldId !==undefined){
                        FieldId1 = stageField['field_001001000018'].FieldId;
                    }

                    stageField['field_001001000018'] = {
                        FieldName   : removeString('field_001001000018'),
                        FieldLabel  : stageField['field_001001000018'].FieldLabel,
                        FieldValue  : new Date(response.data.nextWorkingDate),
                        FieldType   : stageField['field_001001000018'].FieldType,
                        DataType    : stageField['field_001001000018'].DataType,
                        ParentFieldId: stageField['field_001001000018'].ParentFieldId,
                        ChildRowNmbr: stageField['field_001001000018'].ChildRowNmbr,
                        type : stageField['field_001001000018'].type,
                        ContainerFields : stageField['field_001001000018'].ContainerFields,
                    };
                    if(FieldId1 !== '' && FieldId1!==undefined){
                        stageField['field_001001000018']['FieldId'] = FieldId1;
                    }

                    if( name === 'field_001001000004' || name ==='field_001001000005'){
                        if(this.state.fromDate !== '' && this.state.toDate !== ''){
                            let fromDate = moment(this.state.fromDate).format('MM/DD/YYYY');
                            let toDate = moment(this.state.toDate).format('MM/DD/YYYY');
                            let requestedFor = this.state.requestedFor;
                            let timeoffTypeId = this.state.timeoffTypeId;
                            let ProcessValidation = {};
                            ProcessValidation = {
                                EmployeeID : requestedFor,
                                FromDate: fromDate,
                                ToDate: toDate,
                                CompanyID : "A0BA923B-5157-4996-A1DB-6105CD5FE752",
                                Type : timeoffTypeId.toString(),
                                RequestDate: fromDate,
                                TimeOffTypeId : timeoffTypeId,
                                RequestID : timeoffTypeId,
                                RequestedFor : requestedFor,
                                RequestType : timeoffTypeId,
                                ProcessID : timeoffTypeId,
                            };

                            let dd = JSON.stringify(ProcessValidation);
                            let  datas = {Key : dd};

                            this.setState({loading: true});
                            axios.post('/master/api/GetDays', JSON.stringify(datas))
                            .then((response) => {
                                if(response.status == 200){

                                    let noOfDays = response.data.statusCode;

                                    // to update number of leave days
                                    let FieldId4 = '';
                                    if(stageField['field_001001000037'].FieldId !=='' || stageField['field_001001000037'].FieldId !==undefined){
                                        FieldId4 = stageField['field_001001000037'].FieldId;
                                    }

                                    stageField['field_001001000037'] = {
                                        FieldName   : removeString('field_001001000037'),
                                        FieldLabel  : stageField['field_001001000037'].FieldLabel,
                                        FieldValue  : noOfDays,
                                        FieldType   : stageField['field_001001000037'].FieldType,
                                        DataType    : stageField['field_001001000037'].DataType,
                                        ParentFieldId: stageField['field_001001000037'].ParentFieldId,
                                        ChildRowNmbr: stageField['field_001001000037'].ChildRowNmbr,
                                        type : stageField['field_001001000037'].type,
                                        ContainerFields : stageField['field_001001000037'].ContainerFields,
                                    };
                                    if(FieldId4 !== '' && FieldId4!==undefined){
                                        stageField['field_001001000037']['FieldId'] = FieldId4;
                                    }
                                    
                                    this.setState({loading: false});
                                }
                            }).catch((error) => {
                                this.growl.show({severity: 'error', summary: null, detail: 'Number of Leave Days API Failed'});
                                this.setState({loading: false});
                            })
                        }                        
                    }
                 
                    this.setState({loading:false});
                }).catch(err => {
                    this.growl.show({severity: 'error', summary: null, detail: 'Next Working Date API Failed'});
                    this.setState({loading:false});
                })            
        }

        indexStage['stageFields'] = stageField;
        copyStages[Index] = indexStage;
        this.setState({stages: copyStages});
        
    }

    


    handleImageChange = (e, Index, FieldLabel, FieldType, DataType,ParentFieldId,ChildRowNmbr ) => {
        e.preventDefault();
        this.setState({loading:true});
        let file = e.target.files[0];
        let names= 'ExaminationLeaveRequest_Attachments_'+UPLOAD_NAME_CONCAT+'_'+file.name;
        const frmData = new FormData();
        frmData.append('file', file,  names );
        return axios.post('/master/api/upload?FolderName=ExaminationLeaveAttachments', frmData ).then(response =>{
         
            setTimeout(() => {
                let copyStages = [...this.state.stages];
                let indexStage = copyStages[Index];
                let stageField = indexStage.stageFields;

                stageField['field_001001000027'] = {
                    FieldName   : removeString('field_001001000027'),
                    FieldLabel  : FieldLabel,
                    FieldValue  : response.data.filePath,
                    FieldType   : FieldType,
                    DataType    : DataType,
                    ParentFieldId: ParentFieldId,
                    ChildRowNmbr: ChildRowNmbr,
                    type : stageField['field_001001000027'].type,
                    ContainerFields : stageField['field_001001000027'].ContainerFields,
                    FieldId : stageField['field_001001000027'].FieldId,
                };
        
                indexStage['stageFields'] = stageField;
                copyStages[Index] = indexStage;
                this.setState({stages: copyStages,loading:false});
            },1000)
            
        })
        .catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'File Upload Failed'});
            this.setState({loading:false});
        })  
    }

    addVisaAction = () => {
        let dateFormat = this.props.userPref.dateFormat;
        let data = [...this.state.visaActionDetails,{            
            visano : this.state.EXITREENTRYVISANUMBER,
            countryvisano: this.state.VISITINGCOUNTRYVISANUMBER,
            visaissuedate:  DateFormetter(this.state.EXITREENTRYVISAISSUEDATE,dateFormat),
            visaexpirydate:  DateFormetter(this.state.EXITREENTRYVISAEXPIRYDATE,dateFormat),
            countryissuedate:  DateFormetter(this.state.VISITINGCOUNTRYISSUEDATE,dateFormat),
            countryexpirydate:  DateFormetter(this.state.VISITINGCOUNTRYEXPIRYDATE,dateFormat),
            comments : this.state.visaComments
        }]
        
        this.setState({visaActionDetails:data})

        // ,EXITREENTRYVISAISSUEDATE:'',EXITREENTRYVISAEXPIRYDATE:'',VISITINGCOUNTRYISSUEDATE:'',VISITINGCOUNTRYEXPIRYDATE:'',EXITREENTRYVISANUMBER:'',VISITINGCOUNTRYVISANUMBER:'',visaComments:''
    }

    addTicketAction = () => {
        let dateFormat = this.props.userPref.dateFormat;
        let data = [...this.state.ticketActionDetails,{            
            ticketPerson : this.state.ticketPerson,
            
            TICKET_NUMBER: this.state.TICKET_NUMBER,
            TICKET_PNR: this.state.TICKET_PNR,
            TICKET_AIRLINE: this.state.TICKET_AIRLINE,
            TICKET_FROM_AIRPORT: this.state.TICKET_FROM_AIRPORT,
            TICKET_TO_AIRPORT: this.state.TICKET_TO_AIRPORT,
            TICKET_DATE_OF_JOURNEY:  DateFormetter(this.state.TICKET_DATE_OF_JOURNEY,dateFormat),
            RETURN_TICKET_NUMBER: this.state.RETURN_TICKET_NUMBER,
            RETURN_TICKET_PNR: this.state.RETURN_TICKET_PNR,
            RETURN_TICKET_AIRLINE: this.state.RETURN_TICKET_AIRLINE,
            RETURN_TICKET_FROM_AIRPORT: this.state.RETURN_TICKET_FROM_AIRPORT,
            RETURN_TICKET_TO_AIRPORT: this.state.RETURN_TICKET_TO_AIRPORT,
            RETURN_TICKET_DATE_OF_JOURNEY:  DateFormetter(this.state.RETURN_TICKET_DATE_OF_JOURNEY,dateFormat),
            TICKET_CANCEL_BEFORE_DATE1:  DateFormetter(this.state.TICKET_CANCEL_BEFORE_DATE1,dateFormat),
            TICKET_CANCEL_VALUE_BEFORE_DATE1: this.state.TICKET_CANCEL_VALUE_BEFORE_DATE1,
            TICKET_CANCEL_BEFORE_DATE2:  DateFormetter(this.state.TICKET_CANCEL_BEFORE_DATE2,dateFormat),
            TICKET_CANCEL_VALUE_BEFORE_DATE2: this.state.TICKET_CANCEL_VALUE_BEFORE_DATE2,
            TICKET_CANCEL_BEFORE_DATE3:  DateFormetter(this.state.TICKET_CANCEL_BEFORE_DATE3,dateFormat),
            TICKET_CANCEL_VALUE_BEFORE_DATE3: this.state.TICKET_CANCEL_VALUE_BEFORE_DATE3,
            ticketComments : this.state.ticketComments
        }]
        this.setState({ticketActionDetails:data});
        // this.setState({ticketActionDetails:data,TICKET_NUMBER:'',TICKET_PNR:'',TICKET_AIRLINE:'',TICKET_FROM_AIRPORT:'',TICKET_TO_AIRPORT:'',TICKET_DATE_OF_JOURNEY:'',RETURN_TICKET_NUMBER:'',RETURN_TICKET_PNR:'',RETURN_TICKET_AIRLINE:'',RETURN_TICKET_FROM_AIRPORT:'',RETURN_TICKET_TO_AIRPORT:'',RETURN_TICKET_DATE_OF_JOURNEY:'',TICKET_CANCEL_BEFORE_DATE1:'',TICKET_CANCEL_BEFORE_DATE2:'',TICKET_CANCEL_BEFORE_DATE3:'',TICKET_CANCEL_VALUE_BEFORE_DATE1:'',TICKET_CANCEL_VALUE_BEFORE_DATE2:'',TICKET_CANCEL_VALUE_BEFORE_DATE3:'',     
        // ticketComments:''})
    }

    addTransportAction = () => {
        let dateFormat = this.props.userPref.dateFormat;

        let data = [...this.state.transportActionDetails,{            
            // person : this.state.selectPerson,
            Comments: this.state.transportComments,
            transportationdate:  DateFormetter(this.state.TRANSPORTATIONDATETIME,dateFormat),
            transportationfrom:  this.state.TRANSPORTATIONFROM,
            transportationto:  this.state.TRANSPORTATIONTO,
        }]

        this.setState({transportActionDetails:data})
        // ,transportComments:'',TRANSPORTATIONDATETIME:'',TRANSPORTATIONFROM:'',TRANSPORTATIONTO:'',selectPerson:'All'
    }

    addActionGrid = () => {
        let dateFormat = this.props.userPref.dateFormat;
        let data = [...this.state.actionDefenitions,{            
            createdBy   : this.props.loggedUserDetail.empID,
            actiontype  : this.state.selectedAction,
            targetdate  :  DateFormetter(this.state.selectedTargetDate,'MM/dd/yyyy'),
            responsibledepartment    :  this.state.selectedDepartment,
            assignedTo      :  this.state.selectedPerson,
            status      :   this.state.actionStatus,
            actiondescription    :   this.state.actionComments,
        }]
        this.setState({actionDefenitions: data,selectedAction:null,selectedTargetDate:'',selectedDepartment:null,selectedPerson:null,actionStatus:null,actionComments:''})
    }

    deleteActionGrid  = (data, index) => {
        if(this.state.actionDefenitions.length > 0){
            let rowIndex = index.rowIndex;
            const updatedValue = this.state.actionDefenitions.filter( (value , index) => {
                return index!== rowIndex;
            });  
            this.setState({actionDefenitions:updatedValue});
        }
    }
    actionTemplate = (rowData, column) => {
        return <div className="actionCenter">
                <Button  className="p-button-danger" onClick={() => this.deleteActionGrid(rowData,column)} icon="pi pi-trash"  />
        </div>;
    }


    deleteVisaActionGrid  = (data, index) => {

    if(this.state.visaActionDetails.length > 0){
        let rowIndex = index.rowIndex;
        const updatedValue = this.state.visaActionDetails.filter( (value , index) => {
            return index!== rowIndex;
        });    

        this.setState({visaActionDetails:updatedValue});
    }

    }


    deleteTransportActionGrid = (data, index) => {

        if(this.state.transportActionDetails.length > 0){
            let rowIndex = index.rowIndex;
            const updatedValue = this.state.transportActionDetails.filter( (value , index) => {
                return index!== rowIndex;
            });    
    
            this.setState({transportActionDetails:updatedValue});
        }

    }

    deleteTicketActionGrid = (data, index) => {
       
        if(this.state.ticketActionDetails.length > 0){
            let rowIndex = index.rowIndex;
            const updatedValue = this.state.ticketActionDetails.filter( (value , index) => {
                return index!== rowIndex;
            });    
    
            this.setState({ticketActionDetails:updatedValue});
        }

    }

    ticketactTemplate = (rowData, column) => {
    return <div className="actionCenter">
                <Button  className="p-button-danger" onClick={() => this.deleteTicketActionGrid(rowData,column)} icon="pi pi-trash"  />
        </div>;
    }
                      
    transportactTemplate = (rowData, column) => {
        return <div className="actionCenter">
                    <Button  className="p-button-danger" onClick={() => this.deleteTransportActionGrid(rowData,column)} icon="pi pi-trash"  />
            </div>;
    }

    visaactTemplate = (rowData, column) => {
        return <div className="actionCenter">
                    <Button  className="p-button-danger" onClick={() => this.deleteVisaActionGrid(rowData,column)} icon="pi pi-trash"  />
            </div>;
    }



    rowExpansionTemplate = (data) => {

        return  (
            <div className="p-grid p-fluid" style={{padding: '2em 1em 1em 1em'}}>
                    <div className="p-col-12 p-md-3" style={{textAlign:'center'}}>
                    {data.ticketPerson}
                    </div>
                    <div className="p-col-12 p-md-9">
                    <div className="p-grid">
                        <div className="p-md-3">Ticket Number: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_NUMBER}</div>

                        <div className="p-md-3">Ticket PNR: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_PNR}</div>

                        <div className="p-md-3">Ticket Airline: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_AIRLINE}</div>

                        <div className="p-md-3">Ticket From Airport: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_FROM_AIRPORT}</div>

                        <div className="p-md-3">Ticket To Airport: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_TO_AIRPORT}</div>

                        <div className="p-md-3">Ticket Date Of Journey: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_DATE_OF_JOURNEY}</div>



                        <div className="p-md-3">Return Ticket Number: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.RETURN_TICKET_NUMBER}</div>

                        <div className="p-md-3">Return Ticket PNR: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.RETURN_TICKET_PNR}</div>

                        <div className="p-md-3">Return Ticket Airline: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.RETURN_TICKET_AIRLINE}</div>

                        <div className="p-md-3">Return Ticket From Airport: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.RETURN_TICKET_FROM_AIRPORT}</div>

                        <div className="p-md-3">Return Ticket To Airport: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.RETURN_TICKET_TO_AIRPORT}</div>

                        <div className="p-md-3">Return Ticket Date Of Journey: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.RETURN_TICKET_DATE_OF_JOURNEY}</div>


                        <div className="p-md-3">Ticket Cancel Before Date 1: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_CANCEL_BEFORE_DATE1}</div>

                        <div className="p-md-3">Ticket Value: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_CANCEL_VALUE_BEFORE_DATE1}</div>


                        <div className="p-md-3">Ticket Cancel Before Date 2: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_CANCEL_BEFORE_DATE2}</div>

                        <div className="p-md-3">Ticket Value: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_CANCEL_VALUE_BEFORE_DATE2}</div>

                        <div className="p-md-3">Ticket Cancel Before Date 3: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_CANCEL_BEFORE_DATE3}</div>

                        <div className="p-md-3">Ticket Value: </div>
                        <div className="p-md-3" style={{fontWeight:'bold'}}>{data.TICKET_CANCEL_VALUE_BEFORE_DATE3}</div>


                        <div className="p-md-3">
                            Ticket Comments
                        </div>
                        <div className="p-md-9" style={{fontWeight:'bold'}}>{data.ticketComments}</div>

                     
                    </div>
                </div>
            </div>
        );
    }


    componentDidUpdate(prevProps, prevState){
        if (this.props.tableLists.requestAttribute1 !== undefined && this.state.loadOnce) {
            console.log("Loaded")
            // let { id } = this.state;
     

            
            
            let id = this.props.match.params.id;
            let copyStages =  [...this.state.stages];
            let data = this.props.tableLists;

            if (id == "")
                {
                           let search = window.location.pathname;
   
            let params = new URLSearchParams(search);

            if (id == undefined || id == '' || id == null) {
                
               

                if (search.indexOf('/') != -1) { 
                    if (search.indexOf('/') != -1) {
                        id = search.split('/')[3].split('&')[0];
                    }

                }
            }
                }
            
            //let id = this.props.match.params.id;

           // let id = params.get('id');
            let type = this.props.match.params.type;
            let reqStatus = data.status;
            let requestNum = data.requestNum;
            let stages = [];
            let attachmentData = data.requestattachments || [];
            if(data.requestAttribute1 && data.requestAttribute1.length > 0){            
                stages = data.requestAttribute1.map(((stageList,stageIndex) => {
                    let stageFields = stageList.stage_Field;
                    let stageFieldArray = [];
                    if(stageFields && stageFields.length > 0){
                        stageFieldArray = stageFields.map((fields,fieldIndex) => {
                            let fieldsY = 'field_'+fields.fieldName;
                            if(fieldsY === 'field_001001000001'){
                                let a = fields.fieldValue
                                this.findNationality(a)
                                this.props.getTimeOffData({id: a});
                            }
                            if(fieldsY === 'field_001001000001'){
                          
                                this.props.getDependentDetails(fields.fieldValue);
                                this.props.getQuotaDetails(fields.fieldValue);
                            }

                            let fieldValue = fields.fieldValue;
                            if(fields.fieldType === 8 || fields.fieldType === "8"){
                                fieldValue = new Date(fields.fieldValue);
                            }else if (fields.fieldType === 10  || fields.fieldType === "10"){
                                if(fields.fieldValue === 'true'){
                                    fieldValue = true
                                }else{
                                    fieldValue = false
                                }
                            }

                            if(fields.fieldDescription === 'Request For' && fields.fieldValue){
                                this.props.getTimeOffData({ id: fields.fieldValue }); 
                                this.setState({requestedFor: fields.fieldValue}); 
                            }

                            if(fields.fieldDescription === "Starting Date" && fields.fieldValue){
                                this.setState({fromDate: fields.fieldValue}); 
                            }

                            if(fields.fieldDescription === 'Leave Type' && fields.fieldValue){
                                this.setState({timeoffTypeId: fields.fieldValue}); 
                            }
                            
                            if(fieldsY === 'field_001001000034' && fields.fieldValue){
                                this.setState({ticketRequired: fields.fieldValue}); 
                            }
                           

                            if(fields.fieldDescription === 'Ticket Route From' || fields.fieldDescription === 'Ticket Route To' || fields.fieldDescription === 'Action Type' || fields.fieldDescription === 'Status' || fields.fieldDescription === 'Dependent Relation'){
                                fieldValue = parseInt(fields.fieldValue);
                            }
                             
                            
                            let containerFields = [];
                            if(fields.stage_FieldsList && fields.stage_FieldsList.length > 0){
                                containerFields = fields.stage_FieldsList.map((conFields,conIndex)=>{
                                    let stage_FieldsListc2 = conFields.stage_FieldsListc2.map(conField => {
                                        let containersFieldsY = 'field_'+conField.fieldNum;
                                        let fieldValue = conField.fieldValue;
                                        if(conField.fieldType === 8 || fields.fieldType === "8"){
                                            fieldValue = new Date(conField.fieldValue);
                                        }else if (conField.fieldType === 10  || fields.fieldType === "10"){
                                            if(conField.fieldValue === 'true'){
                                                fieldValue = true
                                            }else{
                                                fieldValue = false
                                            }
                                        }

                                        if(conField.fieldDescription === 'Ticket Route From' || conField.fieldDescription === 'Ticket Route To' || conField.fieldDescription === 'Action Type' || conField.fieldDescription === 'Status' || conField.fieldDescription === 'Dependent Relation'){
                                            fieldValue = parseInt(conField.fieldValue);
                                        }

                                        let containerValues = {
                                            [containersFieldsY] : {
                                                ChildRowNmbr: conField.childRowNmbr,
                                                DataType: conField.dataType,
                                                FieldLabel: conField.fieldDescription,
                                                FieldName: conField.fieldNum,
                                                FieldType: conField.fieldType,
                                                FieldValue: fieldValue,
                                                ParentFieldId: conField.parentFieldNum,
                                                stageNum : conField.stageNum,
                                                processNum : stageList.processNum,
                                                FieldSequence : conField.fieldSequence,
                                                IsActive: true,
                                                CompanyID : conField.companyId,
                                                StageSequence : stageList.stageSequence,
                                                type: conField.containerType,
                                                FieldId : conField.fieldId,
                                            }
                                        }

                                        return containerValues;
                                    })
                                    var objStageContainerArray = Object.assign({}, ...stage_FieldsListc2);
                                    return objStageContainerArray;
                                })
                            }   

                            let values = {
                                [fieldsY] : {
                                    ChildRowNmbr: fields.childRowNmbr,
                                    DataType: fields.dataType,
                                    FieldLabel: fields.fieldDescription,
                                    FieldName: fields.fieldName,
                                    FieldType: fields.fieldType,
                                    FieldValue: fieldValue,
                                    ParentFieldId: fields.parentFieldId,
                                    stageNum : fields.stageNum,
                                    processNum : stageList.processNum,
                                    FieldSequence : fields.fieldSequence,
                                    IsActive: true,
                                    CompanyID : fields.companyId,
                                    StageSequence : stageList.stageSequence,
                                    type: fields.containerType,
                                    ContainerFields : containerFields,
                                    FieldId : fields.fieldId,
                                }
                            }
                            
                            return values;
                        })
                    }

                    var objStageArray = Object.assign({}, ...stageFieldArray);
                    return {
                        AllowApprove : true,
                        AllowForms : true,
                        AllowAttachments : true,
                        AllowActions : true,
                        Description: stageList.description,
                        stageFields : objStageArray
                    };
                }))
            }
            
            let actionDefenitions = [];
            let filteredAction = [];
            if(data.requestactions && data.requestactions.length > 0){
                actionDefenitions = data.requestactions.map(list => {
                    if(list.requestactionid === this.state.requestactionid || list.assignedTo === this.props.loggedUserDetail.empID){
                        filteredAction.push(list);
                    }
                    return {...list, status:1, createdBy : (list.assignedByEmployeeId!==null) ? list.assignedByEmployeeId : this.props.loggedUserDetail.empID  }
                })


            }          

            if(stages.length == 2){
                //stages.push(copyStages[2]);
            }

            this.reloadAttachmentData(attachmentData);// to reload any attachments of the request
            if (prevState.reqStatus == this.state.reqStatus) {
    this.setState({reqStatus:data.status}) ;
  }
            this.setState({
                type : type, EmpID : data.employeeID,  requestType : data.requestType, stages : stages ,loadOnce : false,  requestNum: requestNum, actionDefenitions: actionDefenitions
            });

          

            if(this.state.actionType === 'Ticket' && this.state.requestactionid!==null && filteredAction.length > 0){
                let ticketActionDetails = filteredAction.map(list=>{
                    return {
                        Actionnum : list.actionnum,
                        Createdby : list.createdby,
                        Actiontype : list.actiontype,
                        Responsibledepartment : list.responsibledepartment,
                        AssignedTo : list.assignedTo,
                        Targetdate : list.targetdate,
                        Actiondescription : list.actiondescription,
                        requestactionid : list.requestactionid,                        
                        RETURN_TICKET_AIRLINE: list.returnTicketAirline,
                        RETURN_TICKET_DATE_OF_JOURNEY:  (list.returnTicketDateOfJourney!==null) ? new Date(list.returnTicketDateOfJourney) : '',
                        RETURN_TICKET_FROM_AIRPORT: list.returnTicketFromAirport,
                        RETURN_TICKET_NUMBER: list.returnTicketNumber,
                        RETURN_TICKET_PNR: list.returnTicketPnr,
                        RETURN_TICKET_TO_AIRPORT: list.returnTicketToAirport,
                        TICKET_AIRLINE:list.ticketAirline,
                        TICKET_CANCEL_BEFORE_DATE1: (list.ticketCancelBeforeDate1!==null) ? new Date(list.ticketCancelBeforeDate1) : '',
                        TICKET_CANCEL_BEFORE_DATE2: (list.ticketCancelBeforeDate2!==null) ? new Date(list.ticketCancelBeforeDate2) : '',
                        TICKET_CANCEL_BEFORE_DATE3: (list.ticketCancelBeforeDate3!==null) ? new Date(list.ticketCancelBeforeDate3) : '',
                        TICKET_CANCEL_VALUE_BEFORE_DATE1: list.ticketCancelValueBeforeDate1,
                        TICKET_CANCEL_VALUE_BEFORE_DATE2: list.ticketCancelValueBeforeDate2,
                        TICKET_CANCEL_VALUE_BEFORE_DATE3: list.ticketCancelValueBeforeDate3,
                        TICKET_DATE_OF_JOURNEY: (list.ticketDateOfJourney!==null) ? new Date(list.ticketDateOfJourney) : '',
                        TICKET_FROM_AIRPORT: list.ticketFromAirport,
                        TICKET_NUMBER: list.ticketNumber,
                        TICKET_PNR: list.ticketPnr,
                        TICKET_TO_AIRPORT: list.ticketToAirport,
                        ticketComments: list.comments,
                        ticketStatus : list.statusId
                    }
                });
               
                this.setState({ticketActionDetails:ticketActionDetails});
            } else if(this.state.actionType === 'Visa' && this.state.requestactionid!==null && filteredAction.length > 0){

                let visaActionDetails = filteredAction.map(list => {
                    return {
                        Actionnum : list.actionnum,
                        Createdby : list.createdby,
                        Actiontype : list.actiontype,
                        Responsibledepartment : list.responsibledepartment,
                        AssignedTo : list.assignedTo,
                        Targetdate : list.targetdate,
                        Actiondescription : list.actiondescription,
                        requestactionid : list.requestactionid,  
                        EXITREENTRYVISANUMBER : list.exitreentryvisanumber,
                        EXITREENTRYVISAISSUEDATE : (list.exitreentryvisaissuedate!==null) ? new Date(list.exitreentryvisaissuedate) : '',
                        EXITREENTRYVISAEXPIRYDATE : (list.exitreentryvisaexpirydate!==null) ? new Date(list.exitreentryvisaexpirydate) : '',
                        VISITINGCOUNTRYVISANUMBER : list.visitingcountryvisanumber,
                        VISITINGCOUNTRYISSUEDATE : (list.visitingcountryissuedate!==null) ? new Date(list.visitingcountryissuedate) : '',
                        VISITINGCOUNTRYEXPIRYDATE : (list.visitingcountryexpirydate!==null) ? new Date(list.visitingcountryexpirydate) : '', 
                        visaComments : list.comments,
                        visaStatus: list.statusId
                    }
                });
                this.setState({visaActionDetails:visaActionDetails});
            } else if(this.state.actionType === 'Transportation' && this.state.requestactionid!==null && filteredAction.length > 0){


                let transportActionDetails = filteredAction.map(list => {
                    return {
                        Actionnum : list.actionnum,
                        Createdby : list.createdby,
                        Actiontype : list.actiontype,
                        Responsibledepartment : list.responsibledepartment,
                        AssignedTo : list.assignedTo,
                        Targetdate : list.targetdate,
                        Actiondescription : list.actiondescription,
                        requestactionid : list.requestactionid,  
                        TRANSPORTATIONDATETIME: (list.transportationdatetime!==null) ? new Date(list.transportationdatetime) : '',
                        TRANSPORTATIONFROM: list.transportationfrom,
                        TRANSPORTATIONTO: list.transportationto,
                        transportComments: list.comments,
                        transportStatus:list.statusId
                    }
                });
                this.setState({transportActionDetails:transportActionDetails});
            }  else if(this.state.actionType === 'Iqama' && this.state.requestactionid!==null && filteredAction.length > 0){

                let iqamaActionDetails = filteredAction.map(list => {
                    return {
                        Actionnum : list.actionnum,
                        Createdby : list.createdby,
                        Actiontype : list.actiontype,
                        Responsibledepartment : list.responsibledepartment,
                        AssignedTo : list.assignedTo,
                        Targetdate : list.targetdate,
                        Actiondescription : list.actiondescription,
                        iqamaComments: list.comments,
                        iqamaStatus:list.statusId
                    }
                });
                this.setState({iqamaActionDetails:iqamaActionDetails});
            } 
        }
    }
    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage( 'request', {containerData: {}, requestAttributeData: {}, keywordValuesList: [], subordinatesListData: [] })
    }

    employeeRender = (rowData) => {
  
        let person = rowData;
        if(this.props.Employee && this.props.Employee.length > 0 ){
            person = this.props.Employee.filter(list=> {
                return list.value === rowData;
            }).reduce((_,el)=> {
                return el.label;
            },'')
        }
        return person;
    }
    
    typeRender  = (rowData) => {
       
        let action = rowData.actiontype;
        if(this.props.ActionType && this.props.ActionType.length > 0 ){
            action = this.props.ActionType.filter(list=> {
                return list.value === rowData.actiontype;
            }).reduce((_,el)=> {
                return el.label;
            },'')
        }
        return action;
    }

    statusRender  = (rowData) => {
 
        let status = rowData.status;
        if(this.props.ActionStatus && this.props.ActionStatus.length > 0 ){
            status = this.props.ActionStatus.filter(list=> {
                return list.value === rowData.status;
            }).reduce((_,el)=> {
                return el.label;
            },'')
        }
        return status;
    }

    departmentRender = (rowData) => {
     
        let deptName = rowData.responsibledepartment;
        if(this.props.GetOrgUnit && this.props.GetOrgUnit.length > 0 ){
            deptName = this.props.GetOrgUnit.filter(list=> {
                return list.value === rowData.responsibledepartment;
            }).reduce((_,el)=> {
                return el.label;
            },'')
        }
        return deptName;
    }

    dynamicSupervisor = () => {
        if(this.state.DynamicSupervisor === null){
            this.growl.show({severity: 'error', summary: null, detail: ' Dynamic supervisor field is required'});
            return;
        }

        if(this.state.reqType ==='return'){

            let Request_WF_LEVEL_ID = this.state.DynamicSupervisorsList.filter(list=>{
                return list.value === this.state.DynamicSupervisor;
            }).reduce((_,el)=>{
                return el.Request_WF_LEVEL_ID;
            },'');

            if(Request_WF_LEVEL_ID!==''){
                this.saveRequest('return','/dashboard',Request_WF_LEVEL_ID);
            }else{
                this.growl.show({severity: 'error', summary: null, detail: ' Something went wrong.'});
                return;
            }
        }else{
            this.saveRequest('submit');
        }

        // this.saveRequest('submit');
    }
    
    render() {
        if(this.props.success){
            REDIRECT_TO_URL('/leave-request-list/',this.props);
        }

        const nationality = localStorage.getItem('nationality');

        const dialogFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({display:false})} label="Close" className="p-button-secondary" />
            </div>
        );

        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({dynamicSupervisorDisplay:false,DynamicSupervisor:null,DynamicSupervisorsList:null})} label="Close" className="p-button-secondary" />
                <Button icon="pi pi-check" disabled={(this.state.DynamicSupervisor===null)} onClick={this.dynamicSupervisor} label="Submit" className="p-button-primary  ml1" />
                
            </div>
        );

  
        const dialogDelegateFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({delegatePopup:false})} label="Close" className="p-button-secondary" />
                <Button icon="pi pi-check" disabled={(this.state.DynamicSupervisor===null)} onClick={() => this.saveRequest(this.state.apiName,'/dashboard','',this.state.hasAttachment,this.state.currentStage)} label="Submit" className="p-button-primary  ml1" />
                
            </div>
        );

     
        let isVisaActionEnabled = (this.state.EXITREENTRYVISANUMBER !== ''  &&  this.state.EXITREENTRYVISAISSUEDATE !== ''  &&  this.state.EXITREENTRYVISAEXPIRYDATE !== '' &&  this.state.VISITINGCOUNTRYVISANUMBER !== ''   &&  this.state.VISITINGCOUNTRYISSUEDATE !== ''   && this.state.VISITINGCOUNTRYEXPIRYDATE !== ''  &&  this.state.visaComments !== '' );


        let isTrasportActionEnabled = (this.state.TRANSPORTATIONDATETIME !== ''  &&  this.state.TRANSPORTATIONFROM !== ''   && this.state.TRANSPORTATIONTO !== ''    &&  this.state.transportComments !== '' ); //(this.state.selectPerson !== '' )  && 

        let isTicketActionEnabled = (this.state.TICKET_NUMBER !== '' && this.state.TICKET_PNR !== '' && this.state.TICKET_TO_AIRPORT !== '' && this.state.TICKET_FROM_AIRPORT !== '' && this.state.TICKET_DATE_OF_JOURNEY !== '' && this.state.TICKET_AIRLINE !== '' && this.state.ticketComments !== '' && this.state.ticketStatus!==null);

        let disabledFun = false;
        if(this.state.requestactionid!==null){
            if(this.state.actionType === 'Ticket'){
                disabledFun = this.state.ticketActionDetails.length==0;
            }else if(this.state.actionType === 'Visa'){
                disabledFun = this.state.visaActionDetails.length==0;
            }else if(this.state.actionType === 'Transportation'){
                disabledFun = this.state.transportActionDetails.length==0;
            }else if(this.state.actionType === 'Iqama'){
                disabledFun = this.state.iqamaComments ==='';
            }
        }
        let quotaDetails = '';
        if(this.props.quotaDetails && this.props.quotaDetails.length > 0){
            quotaDetails = this.props.quotaDetails.map((list,index) =>{
                //return <tr key={index}><td>{list.quotatypeName}</td><td>{list.allocatedDays}</td><td>{list.quotatypeName === "Annual Leave" ? ((list.allocatedDays/12)*8).toFixed(2) : list.allocatedDays}</td><td>{list.usedDays}</td><td>{list.balanceDays}</td><td>{(((list.allocatedDays/12)*8).toFixed(2) - +list.usedDays).toFixed(2)}</td></tr>
                return <tr key={index}><td>{list.quotatypeName}</td><td>{list.allocatedDays}</td><td>{list.usedDays}</td><td>{list.balanceDays}</td></tr>                
            })
            
        }

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );
        let dateFormat = this.props.userPref.dateFormat;

        let isEnabled = (this.state.targetDate !== '' )  && (this.state.selectedForm !== '' ) && (this.state.sendToWho !== '' );
        
        let isActionEnabled = (this.state.selectedAction !== '' )  && (this.state.selectedDepartment !== '' ) && (this.state.selectedPerson !== '' ) && (this.state.selectedTargetDate !== '' ) && (this.state.actionComments !== '' ) && (this.state.actionStatus !== '' );

     

        const hrTeam = parseInt(localStorage.getItem('hrTeam'));
        let relevantOptions = [];
        if (hrTeam) {
            relevantOptions = this.props.Employee.reduce((a, el) => {
                if (el.value !== this.props.loggedUserDetail.empID) {
                    a.push(el);
                }
                return a;
            }, [Object.assign({}, this.props.Employee.find(list => list.value === this.props.loggedUserDetail.empID), {label: 'Self', id: this.props.loggedUserDetail.userID})]);
        } else {
            relevantOptions = (this.props.loggedUserDetail!==null) ? [{label: `${this.props.loggedUserDetail.userName}(Self)`, value: this.props.loggedUserDetail.empID, id: this.props.loggedUserDetail.userID}].concat(this.props.subordinatesListData) : this.props.subordinatesListData;
        }

        if(this.state.currentStage!==0){
            relevantOptions = this.props.Employee;
        }
    
        let dependentDetails = [];
        if(this.props.dependentDetails && this.props.dependentDetails.length > 0){
            dependentDetails = this.props.dependentDetails.map(list=>{
                return { label : list.name, value : list.depandentID}
            })
        }
        let edstatus ='open'
        if (this.state.currentStage !== 0) {
            const { location = {} } = this.props;
            const { state = {} } = location && location.state;
             edstatus = (state && state.editStatus);
        }

        
        return (
            <div className="p-grid leaverequest">
                { this.props.loading && <div className="page-loader"></div>}
                { this.state.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Leave Request</h1>
                        <Dialog header="Leave Policy" visible={this.state.display} modal={true} width="400px" footer={dialogFooter} onHide={() => this.setState({display:false})}>
                        <embed type="application/pdf" 
                            src={PDF}
                            width="100%" style={{height : '60vh',width : '100vh'}} alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" 
                            background-color="0xFF525659" top-toolbar-height="56" full-frame="" internalinstanceid="21" 
                            title="CHROME"/>
                        </Dialog>
                        <Link style={{position: 'absolute',right: '13px', top: '9px'}} to="#">
                            <Button icon="pi pi-file" onClick={() => this.setState({display: true})} label="Policy"/>
                        </Link>
                        {/* {(this.state.currentStage !== 0) ? 
                        <UserInfo userObject={null} requestNum={this.state.requestNum}/> : */}
                        <UserInfo userObject={this.props.userPosInfo} requestNum={this.state.requestNum}/>
                        {/*}*/}
                    </div>
                </div>

                <Dialog header="Select Supervisor" visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({dynamicSupervisorDisplay:false})}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">Select Supervisor<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder="Select Supervisor" name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({DynamicSupervisor:e.target.value})}   {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                            </div> 
                        </div>   
                    </div>
                </Dialog>


                <Dialog header={this.state.popupName} visible={this.state.delegatePopup} modal={true} width="400px" footer={dialogDelegateFooter} onHide={() => this.setState({delegatePopup:false})}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.popupName} <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.popupName}  name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.props.Employee} onChange={(e) => this.setState({DynamicSupervisor:e.target.value})}   {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                            </div> 
                        </div>   
                    </div>
                </Dialog>


                


                
               { this.state.stages.length > 0 && 
                <>
                    {
                        this.state.stages.map((stage,index) => {
                            let stageFields = stage.stageFields;
                            var keys = Object.keys(stageFields);

                           
                         
                            if(index === 0){
                                let stage1Forms = []
                                if(stage.AllowForms && stageFields[keys[30]] && stageFields[keys[30]].FieldName!==undefined){
                                    stage1Forms =  (stageFields[keys[30]].ContainerFields.map((forms,formIndex) => {
                                        var formsKeys = Object.keys(forms);
                                        if(forms[formsKeys[0]].FieldValue!== '' && forms[formsKeys[1]].FieldValue!== '' && forms[formsKeys[2]].FieldValue!== ''){
                                            
                                            let dateValue = '';
                                            if(forms[formsKeys[2]].FieldValue !==''){
                                                 dateValue =  DateFormetter(forms[formsKeys[2]].FieldValue, dateFormat)
                                            }
                                            return {
                                                key : formIndex, form : forms[formsKeys[0]].FieldValue,person : forms[formsKeys[1]].FieldValue,target : dateValue
                                             };
                                        }else{
                                            return {}
                                        }
                                        
                                    }))
                                }
                                
                                let formCounts = 0;
                                if(stage1Forms.length > 0){
                                    formCounts = 1;
                                }

                                let stage1Attachments = []
                                if(stage.AllowAttachments && stageFields[keys[32]] && stageFields[keys[32]].FieldName!==undefined){
                                    stage1Attachments =  (stageFields[keys[32]].ContainerFields.map((forms,formIndex) => {
                                        var formsKeys = Object.keys(forms);
                                        if(forms[formsKeys[0]].FieldValue!== '' && forms[formsKeys[1]].FieldValue!== ''){
                                            return {
                                                key : formIndex, fileName : forms[formsKeys[0]].FieldValue,fileExtension : forms[formsKeys[1]].FieldValue, filePath : forms[formsKeys[2]].FieldValue
                                             };
                                        }else{
                                            return {}
                                        }
                                    }))
                                }
                                stage1Attachments= stage1Attachments.filter(value => Object.keys(value).length !== 0);
                                let attachmentCounts = 0;
                               
                                if(this.state.attachmentData && this.state.hasAttachment == false){
                                    attachmentCounts = 1;
                                    this.setState({hasAttachment : true});
                                    this.setState({loading:false});
                                }


                                let readonly = false;
                                let hideClass ='';
                                if(parseInt(this.state.currentStage) !==index){
                                    readonly = true;
                                    hideClass = 'hide-container';
                                }
                                
                                return(
                                    <>
                                    <div className={hideClass +" p-col-12"}>
                                        
                                        <div className="card card-w-title">

                                            <div className="p-grid">

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Request For<span className="requiredColor">*</span></label>

                                                    <div className="mt1"> 
                                                        <Dropdown readOnly={readonly} placeholder="Request For" options={relevantOptions} value={stageFields[keys[0]].FieldValue} name={keys[0]}  onChange={event => this.updateChangeDetails(event, index, stageFields[keys[0]].FieldLabel, stageFields[keys[0]].FieldType, stageFields[keys[0]].DataType, stageFields[keys[0]].ParentFieldId,stageFields[keys[0]].ChildRowNmbr)} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/> 
                                                    
                                                    </div>
                                                </div>

                                                 <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Request Date<span className="requiredColor">*</span></label>
                                                    <div className="mt1"> 
                                                    <Calendar readOnly={readonly} placeholder="Request Date" value={stageFields[keys[1]].FieldValue} name={keys[1]}  onChange={event => this.updateChangeDetails(event, index, stageFields[keys[1]].FieldLabel, stageFields[keys[1]].FieldType, stageFields[keys[1]].DataType, stageFields[keys[1]].ParentFieldId,stageFields[keys[1]].ChildRowNmbr)} {...CALENDAR_CONFIG}/>
                                                    </div>
                                                </div>


                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Leave Type<span className="requiredColor">*</span></label>
                                                    <div className="mt1"><Dropdown readOnly={readonly} placeholder="Leave Type" className="p-col-12" options={this.props.TimeoffType} value={stageFields[keys[2]].FieldValue} name={keys[2]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[2]].FieldLabel, stageFields[keys[2]].FieldType, stageFields[keys[2]].DataType, stageFields[keys[2]].ParentFieldId,stageFields[keys[2]].ChildRowNmbr)} {...DROPDOWN_CONFIG}/></div>   
                                                </div>
                                                
                                                { (stageFields[keys[0]].FieldValue !== null && this.props.quotaDetails && this.props.quotaDetails.length > 0) &&
                                                <div className="p-col-12" style={{marginTop:'2em',marginBottom:'2em'}}>
                                                    <Fieldset legend="Leave Quota" toggleable={true}>
                                                        <table className="tableBorder">
                                                        <thead>
                                                            <tr style={{background:'#f4f4f4'}}><th scope="col">Leave Type</th><th scope="col">Allocated Days </th><th scope="col">Used Leave</th><th scope="col">Balance days</th></tr>
                                                        </thead>
                                                        <tbody>
                                                            {quotaDetails}
                                                        </tbody>
                                                    </table>
                                                    </Fieldset>
                                                </div>
                                                }


                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Starting date<span className="requiredColor">*</span></label>
                                                    <div className="mt1"><Calendar readOnly={readonly} placeholder="Starting Date" value={stageFields[keys[3]].FieldValue} name={keys[3]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[3]].FieldLabel, stageFields[keys[3]].FieldType, stageFields[keys[3]].DataType, stageFields[keys[3]].ParentFieldId,stageFields[keys[3]].ChildRowNmbr)} {...CALENDAR_CONFIG}/></div>                                
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label  className="label">Ending date<span className="requiredColor">*</span></label>
                                                    <div className="mt1"><Calendar readOnly={readonly} placeholder="Ending Date" value={stageFields[keys[4]].FieldValue} name={keys[4]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[4]].FieldLabel, stageFields[keys[4]].FieldType, stageFields[keys[4]].DataType, stageFields[keys[4]].ParentFieldId,stageFields[keys[4]].ChildRowNmbr)} {...CALENDAR_CONFIG} minDate={this.state.minDate}/></div>                               
                                                </div>

                                                {/* <div className="p-col-12 p-md-6 p-lg-3" visible={false}> uncomment
                                                    <label className="label">Half Day Leave</label>
                                                    <div className="mt1"> <InputSwitch name={keys[5]}  checked={stageFields[keys[5]].FieldValue === true} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[5]].FieldLabel, stageFields[keys[5]].FieldType, stageFields[keys[5]].DataType, stageFields[keys[5]].ParentFieldId,stageFields[keys[5]].ChildRowNmbr)} />
                                                    </div>                                
                                                </div> uncomment for half day functionality */}


                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Reporting date<span className="requiredColor">*</span></label>
                                                    <div className="mt1"><Calendar placeholder="Reporting Date" value={stageFields[keys[6]].FieldValue} name={keys[6]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[6]].FieldLabel, stageFields[keys[6]].FieldType, stageFields[keys[6]].DataType, stageFields[keys[6]].ParentFieldId,stageFields[keys[6]].ChildRowNmbr)} {...CALENDAR_CONFIG} minDate={this.state.minDate}/></div>                               
                                                </div>

                                                <div className="hide-container p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Leave Days<span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputText className="p-col-12" value={stageFields[keys[36]].FieldValue}  name={keys[36]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[36]].FieldLabel, stageFields[keys[36]].FieldType, stageFields[keys[36]].DataType, stageFields[keys[36]].ParentFieldId,stageFields[keys[36]].ChildRowNmbr)} placeholder="Leave Days"/></div>                                
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3" >
                                                        <label className="label">Delegation of Authority required</label>
                                                        <div className="mt1"> <InputSwitch name={keys[34]}  checked={stageFields[keys[34]].FieldValue !== undefined && stageFields[keys[34]].FieldValue === true} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[34]].FieldLabel, stageFields[keys[34]].FieldType, stageFields[keys[34]].DataType, stageFields[keys[34]].ParentFieldId,stageFields[keys[34]].ChildRowNmbr)} />
                                                    </div>      
                                                </div>      

                                                {stageFields[keys[34]].FieldValue === true && 
                                                    <div className="p-col-12 p-md-6 p-lg-3">
                                                        <label className="label">Delegate To<span className="requiredColor">*</span></label>

                                                        <div className="mt1"> 
                                                            <Dropdown readOnly={readonly} placeholder="Delegate To " options={relevantOptions} value={stageFields[keys[35]].FieldValue} name={keys[35]}  onChange={event => this.updateChangeDetails(event, index, stageFields[keys[35]].FieldLabel, stageFields[keys[35]].FieldType, stageFields[keys[35]].DataType, stageFields[keys[35]].ParentFieldId,stageFields[keys[35]].ChildRowNmbr)} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/> 
                                                        
                                                        </div>
                                                    </div>
                                                }
                                                

                                                    {(this.state.ticketRequired === 'true' || this.state.ticketRequired === true) && //(this.state.currentStage===0) && // || nationality!=='SA'
                                                

                                                        <div className="p-col-12 p-md-6 p-lg-3" >
                                                            <label className="label">Visa Required</label>
                                                            <div className="mt1"> <InputSwitch name={keys[28]} checked={stageFields[keys[28]].FieldValue !== undefined && stageFields[keys[28]].FieldValue === true} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[28]].FieldLabel, stageFields[keys[28]].FieldType, stageFields[keys[28]].DataType, stageFields[keys[28]].ParentFieldId, stageFields[keys[28]].ChildRowNmbr)} />
                                                            </div>
                                                        </div>
                                                    }
                                                {!this.state.requestedForIsSaudi &&
                                                    <div className="p-col-12 p-md-6 p-lg-3" visible={false}>
                                                        <label className="label">Ticket Required</label>
                                                        <div className="mt1"> <InputSwitch name={keys[33]}  checked={stageFields[keys[33]].FieldValue !== undefined && stageFields[keys[33]].FieldValue === true} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[33]].FieldLabel, stageFields[keys[33]].FieldType, stageFields[keys[33]].DataType, stageFields[keys[33]].ParentFieldId,stageFields[keys[33]].ChildRowNmbr)} />
                                                    </div>                                
                                                </div>} 


                                                { !this.state.requestedForIsSaudi && (this.state.ticketRequired === 'true' || this.state.ticketRequired === true) &&
                                                <div className="p-col-12 p-md-6 p-lg-3"> {/*modified by ishaaq*/} 
                                                    <label className="label">Ticket Status<span className="requiredColor">*</span></label>
                                                    <br/>
                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                        <div className="p-col-12 p-md-6">
                                                        <RadioButton value="Company" name={keys[7]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[7]].FieldLabel, stageFields[keys[7]].FieldType, stageFields[keys[7]].DataType, stageFields[keys[7]].ParentFieldId,stageFields[keys[7]].ChildRowNmbr)} checked={stageFields[keys[7]].FieldValue === "Company"}/>
                                                        <label htmlFor="rb1" className="p-radiobutton-label">Company</label>
                                                        </div>
                                                        <div className="p-col-12 p-md-6">
                                                        <RadioButton value="Employee"  name={keys[7]}  onChange={event => this.updateChangeDetails(event, index, stageFields[keys[7]].FieldLabel, stageFields[keys[7]].FieldType, stageFields[keys[7]].DataType, stageFields[keys[7]].ParentFieldId,stageFields[keys[7]].ChildRowNmbr)} checked={stageFields[keys[7]].FieldValue === "Employee"}/>
                                                        <label htmlFor="rb2" className="p-radiobutton-label">Employee</label>
                                                        </div>
                                                    </div>                          
                                                </div>}
                                                
                                                { (stageFields[keys[28]].FieldValue === true ||stageFields[keys[28]].FieldValue === 'true' ) &&
                                                    <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Visa Status</label>
                                                    <br/>
                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                        <div className="p-col-12 p-md-6">
                                                        <RadioButton value="Company" name={keys[29]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[29]].FieldLabel, stageFields[keys[29]].FieldType, stageFields[keys[29]].DataType, stageFields[keys[29]].ParentFieldId,stageFields[keys[29]].ChildRowNmbr)} checked={stageFields[keys[29]].FieldValue === "Company"}/>
                                                        <label htmlFor="rb1" className="p-radiobutton-label">Company</label>
                                                        </div>
                                                        <div className="p-col-12 p-md-6">
                                                        <RadioButton value="Employee"  name={keys[29]}  onChange={event => this.updateChangeDetails(event, index, stageFields[keys[29]].FieldLabel, stageFields[keys[29]].FieldType, stageFields[keys[29]].DataType, stageFields[keys[7]].ParentFieldId,stageFields[keys[29]].ChildRowNmbr)} checked={stageFields[keys[29]].FieldValue === "Employee"}/>
                                                        <label htmlFor="rb2" className="p-radiobutton-label">Employee</label>
                                                        </div>
                                                    </div>                          
                                                </div>
                                                }
                                             


                                                { (stageFields[keys[29]].FieldValue === "Employee") && // && nationality!=='SA'
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Sadad Paid <span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputSwitch name={keys[8]}  checked={stageFields[keys[8]].FieldValue === true} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[8]].FieldLabel, stageFields[keys[8]].FieldType, stageFields[keys[8]].DataType, stageFields[keys[8]].ParentFieldId,stageFields[keys[8]].ChildRowNmbr)} />
                                                    </div>                                
                                                </div>
                                                }

                                            
                                                
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Contact during vacation<span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputText className="p-col-12" value={stageFields[keys[9]].FieldValue} name={keys[9]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[9]].FieldLabel, stageFields[keys[9]].FieldType, stageFields[keys[9]].DataType, stageFields[keys[9]].ParentFieldId,stageFields[keys[9]].ChildRowNmbr)} placeholder="Contact during vacation"/></div>                                
                                                </div>
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Mobile<span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputText className="p-col-12" value={stageFields[keys[10]].FieldValue} name={keys[10]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[10]].FieldLabel, stageFields[keys[10]].FieldType, stageFields[keys[10]].DataType, stageFields[keys[10]].ParentFieldId,stageFields[keys[10]].ChildRowNmbr)} placeholder="Mobile"/></div>                                
                                                </div>
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <label className="label">Email address<span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputText className="p-col-12" value={stageFields[keys[11]].FieldValue} name={keys[11]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[11]].FieldLabel, stageFields[keys[11]].FieldType, stageFields[keys[11]].DataType, stageFields[keys[11]].ParentFieldId,stageFields[keys[11]].ChildRowNmbr)}  placeholder="Email address"/></div>                                
                                                </div>
                                            
                                                {/* <div className="p-col-12 p-md-6 p-lg-3"> uncomment for vacation for functionality
                                                    <label className="label">Vacation For<span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <Dropdown placeholder="Select Vacation For" className="p-col-12" options={VACATION_FOR} value={stageFields[keys[12]].FieldValue} name={keys[12]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[12]].FieldLabel, stageFields[keys[12]].FieldType, stageFields[keys[12]].DataType, stageFields[keys[12]].ParentFieldId,stageFields[keys[12]].ChildRowNmbr)}  {...DROPDOWN_CONFIG} />
                                                    
                                                    </div>  uncomment for vacation for functionality                              
                                                </div> */}
 

                                            </div>
                                        </div>
                                    </div>
                                    
                                    {stageFields[keys[2]].FieldValue === EXAMINATION_ID &&
                                        <div className={hideClass +" p-col-12"}>
                                        <div className="card card-w-title">
                                            <h1>Examination Details</h1>
                                            <div className="p-grid">
                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                    <label className="label">Select Institution</label>
                                                    <div className="mt1"> 
                                                        <Dropdown className="p-col-12" placeholder="Select Institution" options={INSTITUTION_LIST} value={stageFields[keys[23]].FieldValue} name={keys[23]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[23]].FieldLabel, stageFields[keys[23]].FieldType, stageFields[keys[23]].DataType, stageFields[keys[23]].ParentFieldId,stageFields[keys[23]].ChildRowNmbr)} selected={stageFields[keys[23]].FieldValue  === INSTITUTION_LIST.value} {...DROPDOWN_CONFIG} />
                                                    </div>
                                                </div>


                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                    <label className="label">Select Course</label>
                                                    <div className="mt1"> 
                                                        <Dropdown className="p-col-12" placeholder="Select Course"  options={COURSE_LIST} value={stageFields[keys[24]].FieldValue} name={keys[24]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[24]].FieldLabel, stageFields[keys[24]].FieldType, stageFields[keys[24]].DataType, stageFields[keys[24]].ParentFieldId,stageFields[keys[24]].ChildRowNmbr)} selected={stageFields[keys[24]].FieldValue  === COURSE_LIST.value} {...DROPDOWN_CONFIG} />
                                                    </div>
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                    <label className="label">Select Year</label>
                                                    <div className="mt1"> 
                                                        <Dropdown className="p-col-12" placeholder="Select Year"  options={YEARS} value={stageFields[keys[25]].FieldValue} name={keys[25]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[25]].FieldLabel, stageFields[keys[25]].FieldType, stageFields[keys[25]].DataType, stageFields[keys[25]].ParentFieldId,stageFields[keys[25]].ChildRowNmbr)} selected={stageFields[keys[25]].FieldValue  === YEARS.value} {...DROPDOWN_CONFIG} />
                                                    </div>
                                                </div>

                                                <div className="p-col-12 p-lg-12">
                                                    <label className="label">Attach Exam Time Table</label>
                                                    <div className="mt1"> 

                                                        <div>
                                                            <input type="file" name="examinationAttachment" id="file-8" className="inputfile inputfile-6" onChange={(e)=>this.handleImageChange(e, index,stageFields[keys[26]].FieldLabel, stageFields[keys[26]].FieldType, stageFields[keys[26]].DataType, stageFields[keys[26]].ParentFieldId,stageFields[keys[26]].ChildRowNmbr)} />
                                                            <label for="file-8"><span></span> <strong><img src={UploadImage} alt="upload im"/> Choose a file&hellip;</strong></label>
                                                        </div>   
                                                        
                                                        {
                                                            (stageFields[keys[26]].FieldValue !== '') &&
                                                            <Button type="button" style={{marginLeft:'2em',position:'relative',top:'-1em'}} icon="pi pi-download" className="p-button-info" ></Button>
                                                        }

                                                        <InputText style={{display:'none'}} className="p-col-12" value={stageFields[keys[26]].FieldValue} name={keys[26]}/>

                                                    </div>
                                                </div>


                                                { (stageFields[keys[27]].ContainerFields!==null) && //field_001001000028
                                        <>
                                        
                                        {   
                                            
                                        stageFields[keys[27]].ContainerFields.map((exam,examIndex) => {
                                
                                        var examkeys = Object.keys(exam);
                                  
                                        return  (
                                                <div className="p-col-12" key={examIndex}>
                                                    <div className="card card-w-title">
                                                        <h1>Examiation Detail {examIndex + 1}</h1>
                                                        <>
                                                            <div style={{float: 'right',position: 'relative', top: '-4em'}}>
                                                                { examIndex === 0 &&
                                                                    <Button onClick={(e) => this.addContainerField(index, examIndex, stageFields[keys[27]].FieldName,examkeys)} className="p-button-primary" title={`Add More`} icon="pi pi-plus"/>
                                                                }  

                                                                { examIndex !== 0 &&
                                                                    <Button onClick={(e) => this.removeContainerField(index, examIndex, stageFields[keys[27]].FieldName)} className="p-button-danger" title={`Remove Exam Detail ${index + 1}`} icon="pi pi-trash"/>
                                                                }   
                                                                
                                                                
                                                            </div>
                                                        </>
                                                        <div className="p-grid">
                                                            <div className="p-col-12 p-md-6 p-lg-4">
                                                                <label className="label">Exam Name</label>
                                                                <div className="mt1"> <InputText className="p-col-12" value={exam[examkeys[0]].FieldValue}  name={exam[examkeys[0]].FieldName} onChange={event => this.updateContainerDetails(event, index, examIndex, exam[examkeys[0]].FieldLabel,exam[examkeys[0]].FieldType,exam[examkeys[0]].DataType,exam[examkeys[0]].ParentFieldId,exam[examkeys[0]].ChildRowNmbr, stageFields[keys[27]].FieldName)} placeholder="Exam Name"  /></div>
                                                            </div>

                                                            <div className="p-col-12 p-md-6 p-lg-4">
                                                                <label className="label">Subject Name</label>
                                                                <div className="mt1"> <InputText className="p-col-12" value={exam[examkeys[1]].FieldValue}  name={exam[examkeys[1]].FieldName} onChange={event => this.updateContainerDetails(event, index, examIndex, exam[examkeys[1]].FieldLabel,exam[examkeys[1]].FieldType,exam[examkeys[1]].DataType,exam[examkeys[1]].ParentFieldId,exam[examkeys[1]].ChildRowNmbr, stageFields[keys[27]].FieldName)} placeholder="Subject Name"  /></div>
                                                            </div>

                                                            <div className="p-col-12 p-md-6 p-lg-4">
                                                                <label className="label">Exam Date</label>
                                                                <div className="mt1"> <Calendar  className="width100" value={exam[examkeys[2]].FieldValue}  name={exam[examkeys[2]].FieldName} onChange={event => this.updateContainerDetails(event, index, examIndex, exam[examkeys[2]].FieldLabel,exam[examkeys[2]].FieldType,exam[examkeys[2]].DataType,exam[examkeys[2]].ParentFieldId,exam[examkeys[2]].ChildRowNmbr, stageFields[keys[27]].FieldName)} placeholder="Exam Date"  {...CALENDAR_CONFIG}/></div>
                                                            </div>

                                                        </div>

                                                    </div>    
                                                </div>
                                                )

                                        })
                                        }
                                        </>
                                    } 
                                            </div>
                                        </div>
                                    </div>
                                    } 



                                    {!this.state.requestedForIsSaudi && (this.state.ticketRequired === 'true' || this.state.ticketRequired === true) &&
                                    <div className={hideClass +" p-col-12"}>
                                        <div className="card card-w-title">
                                            <h1>Ticket Details</h1>
                                            <div className="p-grid">
                                                {/* <div className="p-col-12 p-md-6 p-lg-4">
                                                    <label className="label">Employee name <span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputText className="p-col-12" value={stageFields[keys[13]].FieldValue} name={keys[13]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[13]].FieldLabel, stageFields[keys[13]].FieldType, stageFields[keys[13]].DataType, stageFields[keys[13]].ParentFieldId,stageFields[keys[13]].ChildRowNmbr)}
                                                    disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} placeholder="Employee name"/>
                                                    </div>
                                                </div>
                                                
                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                    <label className="label">Age <span className="requiredColor">*</span></label>
                                                    <div className="mt1"> <InputText className="p-col-12" value={stageFields[keys[14]].FieldValue} name={keys[14]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[14]].FieldLabel, stageFields[keys[14]].FieldType, stageFields[keys[14]].DataType, stageFields[keys[14]].ParentFieldId,stageFields[keys[14]].ChildRowNmbr)} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} placeholder="Employee Age"/>
                                                    </div>
                    
                                                </div>
                    
                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                    <label className="label">Gender</label>
                                                    <div className="p-grid mt1" style={{ marginTop: '0.5em'}}>
                                                        <div className="p-col-12 p-md-6">
                                                            <RadioButton value="Male" name={keys[15]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[15]].FieldLabel, stageFields[keys[15]].FieldType, stageFields[keys[15]].DataType, stageFields[keys[15]].ParentFieldId,stageFields[keys[15]].ChildRowNmbr)} checked={stageFields[keys[15]].FieldValue === 'Male'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                    
                                                            <label htmlFor="rb1" className="p-radiobutton-label">Male</label>
                                                        </div>
                                                        <div className="p-col-12 p-md-6">
                    
                                                            <RadioButton value="Female" name={keys[15]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[15]].FieldLabel, stageFields[keys[15]].FieldType, stageFields[keys[15]].DataType, stageFields[keys[15]].ParentFieldId,stageFields[keys[15]].ChildRowNmbr)} checked={stageFields[keys[15]].FieldValue === 'Female'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                    
                                                            <label htmlFor="rb2" className="p-radiobutton-label">Female</label>
                                                        </div>
                                                </div>
                                                </div>
                                                */}
                                                
                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                    <label className="label">Date of Ticket</label>
                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                        <div className="p-col-12 p-md-12 p-lg-6 p-xs-12">
                                                        <Calendar  placeholder="From Date" value={(stageFields[keys[16]].FieldValue!==null) ? stageFields[keys[16]].FieldValue : ''} name={keys[16]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[16]].FieldLabel, stageFields[keys[16]].FieldType, stageFields[keys[16]].DataType, stageFields[keys[16]].ParentFieldId,stageFields[keys[16]].ChildRowNmbr)} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} {...CALENDAR_CONFIG} /*minDate={this.state.minDate}*//>
                                                        </div>
                                                        <div className="p-col-12 p-md-12 p-lg-6 p-xs-12">
                                                        <Calendar  placeholder="To Date" value={(stageFields[keys[17]].FieldValue!==null) ? stageFields[keys[17]].FieldValue :  ''} name={keys[17]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[17]].FieldLabel, stageFields[keys[17]].FieldType, stageFields[keys[17]].DataType, stageFields[keys[17]].ParentFieldId,stageFields[keys[17]].ChildRowNmbr)} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} {...CALENDAR_CONFIG} /*minDate={this.state.minDate}*//>
                    
                    
                                                        </div>
                                                </div>
                                                </div>
                    
                                            
                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                    <label className="label">Ticket classification</label>
                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                        <div className="p-col-12 p-md-4">
                                                            <RadioButton value="One Way" name={keys[18]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[18]].FieldLabel, stageFields[keys[18]].FieldType, stageFields[keys[18]].DataType, stageFields[keys[18]].ParentFieldId,stageFields[keys[18]].ChildRowNmbr)} checked={stageFields[keys[18]].FieldValue === 'One Way'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                                                            <label htmlFor="rb1" className="p-radiobutton-label">One Way</label>
                                                        </div>
                                                        <div className="p-col-12 p-md-4">
                                                            <RadioButton value="Round Trip" name={keys[18]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[18]].FieldLabel, stageFields[keys[18]].FieldType, stageFields[keys[18]].DataType, stageFields[keys[18]].ParentFieldId,stageFields[keys[18]].ChildRowNmbr)} checked={stageFields[keys[18]].FieldValue === 'Round Trip'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                                                            <label htmlFor="rb2" className="p-radiobutton-label">Round Trip</label>
                                                        </div>
                                                        <div className="p-col-12 p-md-4">
                                                            <RadioButton value="Final Exit" name={keys[18]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[18]].FieldLabel, stageFields[keys[18]].FieldType, stageFields[keys[18]].DataType, stageFields[keys[18]].ParentFieldId,stageFields[keys[18]].ChildRowNmbr)} checked={stageFields[keys[18]].FieldValue === 'Final Exit'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                                                            <label htmlFor="rb2" className="p-radiobutton-label">Final Exit</label>
                                                        </div>
                                                </div>
                                                </div>
                    
                    
                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                    <label className="label">Ticket Route</label>
                                                    <div className="p-grid" >
                                                        <div className="p-col-12 p-md-6">
                                                        <div className="mt1"><Dropdown className="p-col-12" placeholder="Select a City"  options={this.props.Cities} value={stageFields[keys[19]].FieldValue && stageFields[keys[19]].FieldValue.toString()} name={keys[19]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[19]].FieldLabel, stageFields[keys[19]].FieldType, stageFields[keys[19]].DataType, stageFields[keys[19]].ParentFieldId,stageFields[keys[19]].ChildRowNmbr)} selected={stageFields[keys[19]].FieldValue  === this.props.Cities.value} autoWidth={false} {...DROPDOWN_CONFIG} /></div>
                                                        </div>
                                                        <div className="p-col-12 p-md-6">
                                                        <div className="mt1">
                                                        <Dropdown className="p-col-12" placeholder="Select a City" options={this.props.Cities} value={stageFields[keys[20]].FieldValue && stageFields[keys[20]].FieldValue.toString()} name={keys[20]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[20]].FieldLabel, stageFields[keys[20]].FieldType, stageFields[keys[20]].DataType, stageFields[keys[20]].ParentFieldId,stageFields[keys[20]].ChildRowNmbr)} selected={stageFields[keys[20]].FieldValue  === this.props.Cities.value} {...DROPDOWN_CONFIG} />
                                                        </div>
                                                        </div>
                                                </div>
                                                </div>
                    
                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                    <label className="label">Present Location</label>
                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                        <div className="p-col-12 p-md-4">
                    
                                                            <RadioButton value="In KSA" name={keys[21]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[21]].FieldLabel, stageFields[keys[21]].FieldType, stageFields[keys[21]].DataType, stageFields[keys[21]].ParentFieldId,stageFields[keys[21]].ChildRowNmbr)} checked={stageFields[keys[21]].FieldValue  === 'In KSA'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                    
                                                            <label htmlFor="rb1" className="p-radiobutton-label">In KSA</label>
                                                        </div>
                                                        <div className="p-col-12 p-md-4">
                                                        <RadioButton value="Out KSA"  name={keys[21]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[21]].FieldLabel, stageFields[keys[21]].FieldType, stageFields[keys[21]].DataType, stageFields[keys[21]].ParentFieldId,stageFields[keys[21]].ChildRowNmbr)} checked={stageFields[keys[21]].FieldValue  === 'Out KSA'} disabled={this.state.currentStatus.role !== LEAVE_STATUS.NEW} />
                                                            <label htmlFor="rb2" className="p-radiobutton-label">Out of KSA</label>
                                                        </div>
                                                </div>
                                                </div>
                    
                                            
                                            </div>
                                        </div>
                                    </div>}


                                    { (stageFields[keys[22]].ContainerFields!==null && stageFields[keys[12]].FieldValue!=='For me only') && //field_001001000023
                                        <>
                              
                                        {   
                                            
                                        stageFields[keys[22]].ContainerFields.map((dep,depIndex) => {
                                        var depkeys = Object.keys(dep);
                                        return  (
                                                    <div className={hideClass +" p-col-12"} key={depIndex}>
                                                        <div className="card card-w-title">
                                                            <h1>Dependent Details {depIndex + 1}</h1>
                                                            <>
                                                                <div style={{float: 'right',position: 'relative', top: '-4em'}}>
                                                                    { depIndex === 0 &&
                                                                        <Button onClick={(e) => this.addContainerField(index, depIndex, stageFields[keys[22]].FieldName,depkeys)} className="p-button-primary" title={`Add More`} icon="pi pi-plus"/>
                                                                    }  

                                                                    { depIndex !== 0 &&
                                                                        <Button onClick={(e) => this.removeContainerField(index, depIndex, stageFields[keys[22]].FieldName)} className="p-button-danger" title={`Remove Dependent ${index + 1}`} icon="pi pi-trash"/>
                                                                    }   
                                                                    
                                                                    
                                                                </div>
                                                            </>
                                                            <div className="p-grid">

{dep[depkeys[10]]!== undefined && 
                                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                                    <label className="label">Select Dependent</label>
                                                                    <div className="mt1"><Dropdown className="p-col-12" placeholder="Select Dependent" options={dependentDetails} value={dep[depkeys[10]].FieldValue}  name={dep[depkeys[10]].FieldName} onChange={event => {
                                                                        this.updateContainerDetails(event, index, depIndex, dep[depkeys[10]].FieldLabel,dep[depkeys[10]].FieldType,dep[depkeys[10]].DataType,dep[depkeys[10]].ParentFieldId,dep[depkeys[10]].ChildRowNmbr, stageFields[keys[22]].FieldName);
                                                                        this.updateDependentDetails(event, index, depIndex, dep[depkeys[10]].FieldLabel,dep[depkeys[10]].FieldType,dep[depkeys[10]].DataType,dep[depkeys[10]].ParentFieldId,dep[depkeys[10]].ChildRowNmbr, stageFields[keys[22]].FieldName);
                                        }} selected={dep[depkeys[10]].FieldValue === dependentDetails.value} {...DROPDOWN_CONFIG}/></div>
                                                                </div>
                                                              
                                    }

                                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                                    <label className="label">Dependent name</label>
                                                                    <div className="mt1"> <InputText className="p-col-12" value={dep[depkeys[0]].FieldValue}  name={dep[depkeys[0]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[0]].FieldLabel,dep[depkeys[0]].FieldType,dep[depkeys[0]].DataType,dep[depkeys[0]].ParentFieldId,dep[depkeys[0]].ChildRowNmbr, stageFields[keys[22]].FieldName)} placeholder="Dependent name"  /></div>
                                                                </div>

                                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                                    <label className="label">Dependent Relation</label>
                                                                    <div className="mt1">
                                                                    
                                                                    <Dropdown className="p-col-12" placeholder="Select Dependent Relation" options={this.props.relationType} value={dep[depkeys[1]].FieldValue}  name={dep[depkeys[1]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[1]].FieldLabel,dep[depkeys[1]].FieldType,dep[depkeys[1]].DataType,dep[depkeys[1]].ParentFieldId,dep[depkeys[1]].ChildRowNmbr, stageFields[keys[22]].FieldName)}  {...DROPDOWN_CONFIG} />
                                                                    
                                                                    </div>
                                                                </div>


                                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                                    <label className="label">Age</label>
                                                                    <div className="mt1"> <InputText className="p-col-12" placeholder="Age" maxLength="2" value={dep[depkeys[2]].FieldValue}  name={dep[depkeys[2]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[2]].FieldLabel,dep[depkeys[2]].FieldType,dep[depkeys[2]].DataType,dep[depkeys[2]].ParentFieldId,dep[depkeys[2]].ChildRowNmbr, stageFields[keys[22]].FieldName)}/></div>
                                                                </div>
                                                
                                                                <div className="p-col-12 p-md-6 p-lg-4">
                                                                    <label className="label">Gender</label>
                                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                                        <div className="p-col-12 p-md-6">
                                                                            <RadioButton value="Male" checked={dep[depkeys[3]].FieldValue === 'Male'} name={dep[depkeys[3]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[3]].FieldLabel,dep[depkeys[3]].FieldType,dep[depkeys[3]].DataType,dep[depkeys[3]].ParentFieldId,dep[depkeys[3]].ChildRowNmbr, stageFields[keys[22]].FieldName)} />
                                                                            <label htmlFor="rb1" className="p-radiobutton-label">Male</label>
                                                                        </div>
                                                                        <div className="p-col-12 p-md-6">

                                                                                <RadioButton value="Female" checked={dep[depkeys[3]].FieldValue === 'Female'}   name={dep[depkeys[3]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[3]].FieldLabel,dep[depkeys[3]].FieldType,dep[depkeys[3]].DataType,dep[depkeys[3]].ParentFieldId,dep[depkeys[3]].ChildRowNmbr, stageFields[keys[22]].FieldName)} />
                                                                            <label htmlFor="rb2" className="p-radiobutton-label">Female</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                
                                                
                                                        {!this.state.requestedForIsSaudi  && (this.state.ticketRequired === 'true' || this.state.ticketRequired === true) && //modified by ishaaq
                                                            <div className="p-grid">

                                                                
                                                                <div className="p-col-12 p-md-8 p-lg-8">
                                                                    <label className="label">Date of Ticket</label>
                                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                                        <div className="p-col-12 p-md-12 p-lg-6 p-xs-12">

                                                                        <Calendar  placeholder="From Date" value={(dep[depkeys[4]].FieldValue!==null) ? dep[depkeys[4]].FieldValue : ''}  name={dep[depkeys[4]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[4]].FieldLabel,dep[depkeys[4]].FieldType,dep[depkeys[4]].DataType,dep[depkeys[4]].ParentFieldId,dep[depkeys[4]].ChildRowNmbr, stageFields[keys[22]].FieldName)} {...CALENDAR_CONFIG} /*minDate={this.state.minDate}*//>


                                                                        </div>
                                                                        <div className="p-col-12 p-md-12 p-lg-6 p-xs-12">
                                                                        <Calendar  placeholder="To Date" value={(dep[depkeys[5]].FieldValue!==null) ? dep[depkeys[5]].FieldValue : ''}  name={dep[depkeys[5]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[5]].FieldLabel,dep[depkeys[5]].FieldType,dep[depkeys[5]].DataType,dep[depkeys[5]].ParentFieldId,dep[depkeys[5]].ChildRowNmbr, stageFields[keys[22]].FieldName)} {...CALENDAR_CONFIG} /*minDate={this.state.minDate}*//>
                                                                        </div>
                                                                </div>
                                                                </div>
                                    
                                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                                    <label className="label">Ticket classification</label>
                                                                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                                        <div className="p-col-12 p-md-4">

                                                                            <RadioButton  value="One Way" checked={dep[depkeys[6]].FieldValue  === 'One Way'} name={dep[depkeys[6]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[6]].FieldLabel,dep[depkeys[6]].FieldType,dep[depkeys[6]].DataType,dep[depkeys[6]].ParentFieldId,dep[depkeys[6]].ChildRowNmbr, stageFields[keys[22]].FieldName)} />

                                                                            <label htmlFor="rb1" className="p-radiobutton-label">One Way</label>
                                                                        </div>
                                                                        <div className="p-col-12 p-md-4">

                                                                            <RadioButton  value="Round Trip"  checked={dep[depkeys[6]].FieldValue  === 'Round Trip'} name={dep[depkeys[6]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[6]].FieldLabel,dep[depkeys[6]].FieldType,dep[depkeys[6]].DataType,dep[depkeys[6]].ParentFieldId,dep[depkeys[6]].ChildRowNmbr, stageFields[keys[22]].FieldName)} />

                                                                            <label htmlFor="rb2" className="p-radiobutton-label">Round Trip</label>
                                                                        </div>
                                                                        <div className="p-col-12 p-md-4">
                                                                            <RadioButton  value="Final Exit"  checked={dep[depkeys[6]].FieldValue  === 'Final Exit'} name={dep[depkeys[6]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[6]].FieldLabel,dep[depkeys[6]].FieldType,dep[depkeys[6]].DataType,dep[depkeys[6]].ParentFieldId,dep[depkeys[6]].ChildRowNmbr, stageFields[keys[22]].FieldName)} />
                                                                            <label htmlFor="rb2" className="p-radiobutton-label">Final Exit</label>
                                                                        </div>
                                                                </div>
                                                                </div>
                                    
                                    
                                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                                    <label className="label">Ticket Route</label>
                                                                    <div className="p-grid" >
                                                                        <div className="p-col-12 p-md-6">

                                                                        <div className="mt1"><Dropdown className="p-col-12" placeholder="Select a City" options={this.props.Cities} value={dep[depkeys[7]].FieldValue}  name={dep[depkeys[7]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[7]].FieldLabel,dep[depkeys[7]].FieldType,dep[depkeys[7]].DataType,dep[depkeys[7]].ParentFieldId,dep[depkeys[7]].ChildRowNmbr, stageFields[keys[22]].FieldName)} selected={dep[depkeys[7]].FieldValue === this.props.Cities.value} {...DROPDOWN_CONFIG}/></div>


                                                                        </div>
                                                                        <div className="p-col-12 p-md-6">
                                                                    
                                                                        <div className="mt1"><Dropdown className="p-col-12" placeholder="Select a City"  options={this.props.Cities} value={dep[depkeys[8]].FieldValue}  name={dep[depkeys[8]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[8]].FieldLabel,dep[depkeys[8]].FieldType,dep[depkeys[8]].DataType,dep[depkeys[8]].ParentFieldId,dep[depkeys[8]].ChildRowNmbr, stageFields[keys[22]].FieldName)} selected={dep[depkeys[8]].FieldValue === this.props.Cities.value} {...DROPDOWN_CONFIG} />
                                                                        </div>
                                                                        </div>
                                                                </div>
                                                                </div>
                                    
                                                                <div className="p-col-12 p-md-6 p-lg-6">
                                                                                <label className="label">Present Location</label>
                                                                                <div className="p-grid" style={{ marginTop: '0.5em'}}>
                                                                                    <div className="p-col-12 p-md-4">

                                                                                        <RadioButton  value="In KSA"  checked={dep[depkeys[9]].FieldValue  === 'In KSA'} name={dep[depkeys[9]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[9]].FieldLabel,dep[depkeys[9]].FieldType,dep[depkeys[9]].DataType,dep[depkeys[9]].ParentFieldId,dep[depkeys[9]].ChildRowNmbr, stageFields[keys[22]].FieldName)} />

                                                                                        <label htmlFor="rb1" className="p-radiobutton-label">In KSA</label>
                                                                                    </div>
                                                                                    <div className="p-col-12 p-md-4">

                                                                                        <RadioButton  value="Out of KSA"  checked={dep[depkeys[9]].FieldValue  === 'Out of KSA'} name={dep[depkeys[9]].FieldName} onChange={event => this.updateContainerDetails(event, index, depIndex, dep[depkeys[9]].FieldLabel,dep[depkeys[9]].FieldType,dep[depkeys[9]].DataType,dep[depkeys[9]].ParentFieldId,dep[depkeys[9]].ChildRowNmbr, stageFields[keys[22]].FieldName)}  />

                                                                                        <label htmlFor="rb2" className="p-radiobutton-label">Out of KSA</label>
                                                                                    </div>
                                                                            </div>
                                                                            </div>
                                                                </div>}

                                                            </div>

                                                        </div>    
                                                    </div>
                                                )

                                        })
                                        }
                                        </>
                                    }   



                                    {
                                        (stage.AllowForms && stageFields[keys[30]] && stageFields[keys[30]].FieldName!==undefined && false) && 
                                        
                                        <div className={hideClass +" p-col-12"}>
                                            <div className="card card-w-title">
                                                <h1>Forms</h1>
                                                <div className="p-grid ">
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                        <div className="mt1">
                                                            <Dropdown placeholder="Select Form"  name="selectedForm" value={this.state.selectedForm} options={this.state.forms} onChange={(e) => this.setState({selectedForm:e.target.value})} style={{ width: '100%' }} {...DROPDOWN_CONFIG} />
                                                        </div> 
                                                    </div>

                                                    <div className="p-col-12 p-md-6 p-lg-3">
                                                        <div className="mt1">
                                                            <Dropdown placeholder="Send to Whom" name="sendToWho" value={this.state.sendToWho} options={relevantOptions} onChange={(e) => this.setState({sendToWho:e.target.value})} style={{ width: '100%' }}  {...DROPDOWN_CONFIG} />
                                                        </div> 
                                                    </div>

                                                    <div className="p-col-12 p-md-6 p-lg-3">
                                                        <div className="mt1">
                                                            <Calendar placeholder="Target Date"  value={this.state.targetDate} name="targetDate" onChange={e => this.setState({targetDate:e.target.value})} {...CALENDAR_CONFIG}/>
                                                        </div> 
                                                    </div>

                                                    <div className="p-col-12 p-md-6 p-lg-3">
                                                        <div className="mt1">
                                                        <Button disabled={!isEnabled} className="p-button-primary"  icon="pi pi-plus" onClick={event => this.addFormContanier(event, index, stageFields[keys[30]].FieldName,3,formCounts)} label="Add Form" />
                                                        </div> 
                                                    </div>

                                                  
                                                    <div className="p-col-12 p-lg-12">
                                                        <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={stage1Forms}>                            
                                                            <Column field="form"  sortable={true} header="Selected Form" />
                                                            <Column field="person"  sortable={true} header="Selected Person" body={(rowData) => this.employeeRender(rowData.person)}/>
                                                            <Column field="target"  sortable={true} header="Target Date" />                                
                                                            <Column body={(rowData) => this.gridFormsTemplate(rowData,index,stageFields[keys[30]].FieldName)}    header="Action"/>
                                                        </DataTable>
                                                    </div>
                                                    </div>
                                            </div>
                                        </div>
                                    }

                                    {
                                    (stage.AllowAttachments && stageFields[keys[32]] && stageFields[keys[32]].FieldName!==undefined) && 
                                    
                                        <div className={" p-col-12"}>
                                            <div className="card card-w-title">
                                                <h1>Attachments</h1>
                                                <div className="p-grid ">


                                                    { !(parseInt(this.state.currentStage) !==index) && 
                                                    <div className="p-col-12 p-lg-12">
                                                        <div className="mt1">
                                                        <div>
                                                            <input type="file" readOnly={readonly}  name="file" id="file-7" className="inputfile inputfile-6" onChange={(e)=>this.addAttachmentData(e, index,stageFields[keys[32]].FieldName,3,attachmentCounts)} />
                                                            <label for="file-7"><span></span> <strong><img src={UploadImage} alt="upload im"/> Choose a file&hellip;</strong></label>
                                                        </div>                   
                                                                                
                                                        </div> 
                                                    </div>}

                                                    
                                                    <div className="p-col-12 p-lg-12">
                                                        <DataTable className="animated fadeInLeft" rowHover emptyMessage="No files attached..." responsive={true}  rows={10} value={this.state.attachmentData}>                            
                                                            <Column field="fileName"  sortable={true} header="File Name" />
                                                            <Column field="fileExtension"  sortable={true} header="File Extension"/> 
                                                            <Column field="filePath"  sortable={true} header="Download" body={this.downloadTemplate} />                            
                                                            {!(parseInt(this.state.currentStage) !==index) && <Column body={(rowData) => this.deleteAttachmentTemplate(rowData,index,stageFields[keys[32]].FieldName)}    header="Action"/>}
                                                        </DataTable>
                                                    </div>
                                                    </div>
                                            </div>
                                        </div>
                                    }
                                            
                                    {(stageFields[keys[31]] && stageFields[keys[31]].FieldName!==undefined) && 
                                        <div className={hideClass +" p-col-12"}>
                                            <div className="card card-w-title">
                                                <h1>Remarks</h1>
                                                <div className="p-grid ">
                                                    <div className="p-col-12 p-lg-12">
                                                        <InputTextarea readOnly={readonly} rows={3} cols={30} className="width100" placeholder="Remarks" value={stageFields[keys[31]].FieldValue} name={keys[31]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[31]].FieldLabel, stageFields[keys[31]].FieldType, stageFields[keys[31]].DataType, stageFields[keys[31]].ParentFieldId,stageFields[keys[31]].ChildRowNmbr)} autoResize={true}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>  
                                    }

                                    {/* {(stageFields[keys[31]] && stageFields[keys[31]].FieldName!==undefined) && 
                                        <div className={hideClass +" p-col-12"}>
                                            <div className="card card-w-title">
                                                <h1 style={{textAlign:'center'}}>Acknowledgement</h1>
                                                <div className="p-grid vertical-container">
                                                    <div className="p-col-1 p-lg-1 p-col-align-center">
                                                        <InputSwitch name={keys[37]}  checked={stageFields[keys[37]].FieldValue !== undefined && stageFields[keys[37]].FieldValue === true} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[37]].FieldLabel, stageFields[keys[37]].FieldType, stageFields[keys[37]].DataType, stageFields[keys[37]].ParentFieldId,stageFields[keys[37]].ChildRowNmbr)} />
                                                    </div>

                                                    <div className="p-col-11 p-lg-11">
                                                        <label className="label"><strong>I hereby confirm and acknowledge that I have read and understood AZN O&amp;M Company’s travel policy with respect to Covid 19. I understand that if I travel outside the country for any reason, my travel will be on my own risk and responsibility, subject to consequences of unpaid leaves , loss of bonus and implied risks on visa, residence status and any other risks associated with the country’s situation and change in travel rules.</strong></label>    
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>  
                                    } */}


                                    </>
                                )  
                            }
                            else if((index === 1 && parseInt(this.state.currentStage) >= index && this.state.type ==='edit') || (index === 1 && this.state.currentStage===0 && stageFields[keys[0]].FieldValue!=='')){
                          
                                let readonly = false;
                                let hideClass ='';
                                if(parseInt(this.state.currentStage) !==index){
                                    readonly = true;
                                    hideClass = 'hide-container';
                                } 

                                return (
                                    <>
                                    {((stageFields[keys[0]] && stageFields[keys[0]].FieldName!==undefined && parseInt(this.state.currentStage)  >= index) || (index === 1 && this.state.currentStage===0 && stageFields[keys[0]].FieldValue!=='')) && 

                                        <div className={hideClass +" p-col-12"}>
                                            <div className="card card-w-title">
                                                <h1>{stage.Description}</h1>
                                                <div className="p-grid ">
                                                    <div className="p-col-12 p-lg-12">
                                                        <InputTextarea readOnly={readonly} rows={3} cols={30} className="width100" placeholder="Remarks" value={stageFields[keys[0]].FieldValue} name={keys[0]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[0]].FieldLabel, stageFields[keys[0]].FieldType, stageFields[keys[0]].DataType, stageFields[keys[0]].ParentFieldId,stageFields[keys[0]].ChildRowNmbr)} autoResize={true}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>  
    
                                    }
                                    </>
                                )
                                
                            }
                            else if((index === 2 && this.state.currentStage >= index && this.state.requestactionid === null) || (index === 2 && this.state.currentStage===0 && stageFields[keys[0]].FieldValue!=='')){
  
                                let readonly = false;
                                let hideClass ='';
                                if(parseInt(this.state.currentStage) !==index){
                                    readonly = true;
                                    hideClass = 'hide-container';
                                }
                                return (
                                    <>
                                    <div className={hideClass +" p-col-12"}>
                                        <div className="card card-w-title">
                                            {/* <h1>Action Details</h1> 
                                                as requested for backend suppression of action details
                                            */}
                                            <div className="p-grid ">
                                            
                                                { false && 
                                                <>
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Dropdown placeholder="Select Action Type"  name="selectedAction" value={this.state.selectedAction} options={this.props.ActionType} onChange={(e) => this.setState({selectedAction:e.target.value})} style={{ width: '100%' }}  {...DROPDOWN_CONFIG}/>
                                                    </div> 
                                                </div>
                                                
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Dropdown placeholder="Select Department" name="selectedDepartment" value={this.state.selectedDepartment} options={this.props.GetOrgUnit} onChange={(e) => this.setState({selectedDepartment:e.target.value})} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Dropdown placeholder="Assigned To" name="selectedPerson" value={this.state.selectedPerson} options={relevantOptions} onChange={(e) => this.setState({selectedPerson:e.target.value})} style={{ width: '100%' }} {...DROPDOWN_CONFIG} />
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Calendar placeholder="Target Date" value={this.state.selectedTargetDate} name="selectedTargetDate" onChange={e => this.setState({selectedTargetDate:e.target.value})} {...CALENDAR_CONFIG}/>
                                                    </div> 
                                                </div>  

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Dropdown placeholder="Select Status" name="actionStatus" value={this.state.actionStatus} options={this.props.ActionStatus} onChange={(e) => this.setState({actionStatus:e.target.value})} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12  p-md-6 p-lg-9">
                                                    <div className="mt1">
                                                        <InputTextarea rows={3} className="p-col-12" value={this.state.actionComments} name="actionComments" onChange={e => this.setState({actionComments:e.target.value})} cols={30} placeholder="Comments..." autoResize={true} />
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Button disabled={!isActionEnabled} className="p-button-primary"  icon="pi pi-plus" onClick={this.addActionGrid} label="Add Action" />
                                                    </div> 
                                                </div>
                                                </>
                                                }
                                           
                                                {this.state.actionDefenitions && this.state.actionDefenitions.length > 0 &&     
                                                <div className="p-col-12 p-lg-12">
                                                    <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={this.state.actionDefenitions}>  

                                                        {parseInt(this.state.currentStage) === 3 && 
                                                        <Column field="createdBy"  sortable={true} header="Assigned By"  body={(rowData) => this.employeeRender(rowData.createdBy)}/>}
                                                        
                                                        <Column field="actiondescription"  header="Action Name"   />{/*Changed By Ishaaq*/}
                                                        <Column field="responsibledepartment"  header="Assigned To - Department" body={this.departmentRender} />      
                                                        <Column field="assignedTo"   header="Assigned To - Person" body={(rowData) => this.employeeRender(rowData.assignedTo)}/>      
                                                        <Column field="targetdate"   header="Target Date" />  
                                                        <Column field="status" header="Status" sortable={true} body={this.statusRender} />  
                                                        <Column field="comments" header="Comment" />                         
                                                        <Column header="Action" body={this.actionTemplate}/>
                                                    </DataTable>
                                                </div>
                                                }

                                                <h1>{stage.Description}</h1>
                                                <div className="p-col-12 p-lg-12">
                                                    <InputTextarea readOnly={readonly} rows={3} cols={30} className="width100" placeholder="Remarks" value={stageFields[keys[0]].FieldValue} name={keys[0]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[0]].FieldLabel, stageFields[keys[0]].FieldType, stageFields[keys[0]].DataType, stageFields[keys[0]].ParentFieldId,stageFields[keys[0]].ChildRowNmbr)} autoResize={true}/>
                                                </div>




                                                </div>
                                        
                                        
                                        </div>
                                    </div>
                                    </>
                                )
                            }

                            else if((index === 3 && parseInt(this.state.currentStage) >= index &&  this.state.type ==='edit' && this.state.actionType=== null) || (index === 3 && this.state.currentStage===0 && stageFields[keys[0]].FieldValue!=='')){
                                let readonly = false;
                                let hideClass ='';
                                if(parseInt(this.state.currentStage) !==index){
                                    readonly = true;
                                    hideClass = 'hide-container';
                                }
                           
                              
                                return (
                                    <>
                                    {((stageFields[keys[0]] && stageFields[keys[0]].FieldName!==undefined && parseInt(this.state.currentStage)  >= index) || (index === 3 && this.state.currentStage===0 && stageFields[keys[0]].FieldValue!=='')) && 

                                        <div className={hideClass +" p-col-12"}>
                                            <div className="card card-w-title">
                                            <h1>{stage.Description}</h1>
                                                <div className="p-grid ">
                                                    <div className="p-col-12 p-lg-12">
                                                        <InputTextarea readOnly={readonly} rows={3} cols={30} className="width100" placeholder="Remarks" value={stageFields[keys[0]].FieldValue} name={keys[0]} onChange={event => this.updateChangeDetails(event, index, stageFields[keys[0]].FieldLabel, stageFields[keys[0]].FieldType, stageFields[keys[0]].DataType, stageFields[keys[0]].ParentFieldId,stageFields[keys[0]].ChildRowNmbr)} autoResize={true}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>  
    
                                    }
                                    </>
                                )
                                
                            }
                        })
                    }
                </>

                }
              
                
                    { (this.state.actionType === 'Ticket') && // || (this.state.currentStage===0 && this.state.reqStatus==='Closed')
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h1>Ticket Action</h1>

                            { (this.state.ticketActionDetails && this.state.ticketActionDetails.length > 0) && 
                                <>
                                { this.state.ticketActionDetails.map((ticket,indexTicket) => {
                                    return(
                                        <div className="p-grid" key={indexTicket}>
                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_NUMBER} name="TICKET_NUMBER" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket Number" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_PNR} name="TICKET_PNR" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket PNR" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_AIRLINE} name="TICKET_AIRLINE" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket Airline" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_FROM_AIRPORT} name="TICKET_FROM_AIRPORT" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket From Airport" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_TO_AIRPORT} name="TICKET_TO_AIRPORT" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket To Airport" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Calendar placeholder="Date Of Journey" value={ticket.TICKET_DATE_OF_JOURNEY} name="TICKET_DATE_OF_JOURNEY" onChange={e => this.changeActions(e,indexTicket,'ticket')} {...CALENDAR_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.RETURN_TICKET_NUMBER} name="RETURN_TICKET_NUMBER" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Return Ticket Number" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.RETURN_TICKET_PNR} name="RETURN_TICKET_PNR" onChange={e => this.changeActions(e,indexTicket,'ticket')} placeholder="Return Ticket PNR" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.RETURN_TICKET_AIRLINE} name="RETURN_TICKET_AIRLINE" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Return Ticket Airline" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.RETURN_TICKET_FROM_AIRPORT} name="RETURN_TICKET_FROM_AIRPORT" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Return Ticket From Airport" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.RETURN_TICKET_TO_AIRPORT} name="RETURN_TICKET_TO_AIRPORT" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Return Ticket To Airport" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Calendar placeholder="Return Date Of Journey" value={ticket.RETURN_TICKET_DATE_OF_JOURNEY} name="RETURN_TICKET_DATE_OF_JOURNEY" onChange={e => this.changeActions(e,indexTicket,'ticket')} {...CALENDAR_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-9">
                                    <div className="mt1">
                                        <InputTextarea rows={3} className="p-col-12" value={ticket.ticketComments} name="ticketComments" onChange={e => this.changeActions(e,indexTicket,'ticket')} cols={30} placeholder="Comments..." autoResize={true} />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Calendar placeholder="Ticket Cancel Before Date" value={ticket.TICKET_CANCEL_BEFORE_DATE1} name="TICKET_CANCEL_BEFORE_DATE1" onChange={e => this.changeActions(e,indexTicket,'ticket')} {...CALENDAR_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_CANCEL_VALUE_BEFORE_DATE1} name="TICKET_CANCEL_VALUE_BEFORE_DATE1" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket Value" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Calendar placeholder="Ticket Cancel Before Date" value={ticket.TICKET_CANCEL_BEFORE_DATE2} name="TICKET_CANCEL_BEFORE_DATE2" onChange={e => this.changeActions(e,indexTicket,'ticket')} {...CALENDAR_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_CANCEL_VALUE_BEFORE_DATE2} name="TICKET_CANCEL_VALUE_BEFORE_DATE2" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket Value" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Calendar placeholder="Ticket Cancel Before Date" value={ticket.TICKET_CANCEL_BEFORE_DATE3} name="TICKET_CANCEL_BEFORE_DATE3" onChange={e => this.changeActions(e,indexTicket,'ticket')} {...CALENDAR_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-12 p-lg-3">
                                    <div className="mt1">
                                        <InputText className="p-col-12" value={ticket.TICKET_CANCEL_VALUE_BEFORE_DATE3} name="TICKET_CANCEL_VALUE_BEFORE_DATE3" onChange={e => this.changeActions(e,indexTicket,'ticket')}  placeholder="Ticket Value" />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Dropdown placeholder="Select Status" name="ticketStatus" value={ticket.ticketStatus} options={this.props.ActionStatus} onChange={e => this.changeActions(e,indexTicket,'ticket')} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-lg-12">  <hr/> </div>
                                        </div>
                                    )
                                })}
                                
                                {/* <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Button disabled={!isTicketActionEnabled} className="p-button-primary"  icon="pi pi-check" onClick={this.addTicketAction} label="Save" />
                                    </div> 
                                </div> */}
                            
                                </>
                                }
                                
                                {/* <div className="p-col-12 p-lg-12">
                                    <DataTable value={this.state.ticketActionDetails} expandedRows={this.state.expandedRows} onRowToggle={(e) => this.setState({expandedRows:e.data})}
                                            rowExpansionTemplate={this.rowExpansionTemplate} dataKey="ticketPerson">
                                        <Column expander={true}  style={{width: '3em'}} />
                                        <Column field="TICKET_NUMBER" header="Ticket Number" />
                                        <Column field="TICKET_PNR" header="Ticket PNR" />
                                        <Column field="TICKET_AIRLINE" header="Ticket Airline" />
                                        <Column body={this.ticketactTemplate}  header="Action"/>
                                    </DataTable>
                                </div> */}
                                </div>
                        
                        
                    </div>
                    }
                    { (this.state.actionType === 'Transportation') &&
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h1>Transportation Action</h1>
                           
                            {/* <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Dropdown placeholder="Select Person" position="top" name="selectPerson" value={this.state.selectPerson} options={this.state.employees} onChange={(e) => this.setState({selectPerson:e.target.value})} style={{ width: '100%' }} filter={true} showClear={true} />
                                    </div> 
                                </div> */}

                                
                                { (this.state.transportActionDetails && this.state.transportActionDetails.length > 0) && 
                                <>
                                { this.state.transportActionDetails.map((transport,indexTransport) => {
                                return(
                                    <div className="p-grid" key={indexTransport}>
                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Calendar placeholder="Transporation Date" showTime={true} value={transport.TRANSPORTATIONDATETIME} name="TRANSPORTATIONDATETIME" onChange={e => this.changeActions(e,indexTransport,'transport')} {...CALENDAR_CONFIG}/>
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Transporation From" options={this.props.Cities} value={transport.TRANSPORTATIONFROM} name="TRANSPORTATIONFROM" onChange={e => this.changeActions(e,indexTransport,'transport')}  {...DROPDOWN_CONFIG} />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Dropdown className="p-col-12" placeholder="Transporation To"  value={transport.TRANSPORTATIONTO} name="TRANSPORTATIONTO" options={this.props.Cities} onChange={e => this.changeActions(e,indexTransport,'transport')}  {...DROPDOWN_CONFIG} />
                                    </div> 
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Dropdown placeholder="Select Status" name="transportStatus" value={transport.transportStatus} options={this.props.ActionStatus} onChange={e => this.changeActions(e,indexTransport,'transport')} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/>
                                    </div> 
                                </div>


                                <div className="p-col-12 p-md-12 p-lg-12">
                                    <div className="mt1">
                                        <InputTextarea rows={3} className="p-col-12" value={transport.transportComments} name="transportComments" onChange={e => this.changeActions(e,indexTransport,'transport')} cols={30} placeholder="Comments..." {...DROPDOWN_CONFIG} />
                                    </div> 
                                </div>
                            
                                <div className="p-col-12 p-lg-12">  <hr/> </div>
                                        </div>
                                    )
                                })}

                                {/* <div className="p-col-12 p-md-6 p-lg-3">
                                    <div className="mt1">
                                        <Button disabled={!isTrasportActionEnabled} className="p-button-primary"  icon="pi pi-check" onClick={this.addTransportAction} label="Save" />
                                    </div> 
                                </div> */}
                                </>
                                }


                                {/* <div className="p-col-12 p-lg-12">
                                    <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={this.state.transportActionDetails}>                        
                                        <Column field="transportationdate"  sortable={true} header="Transporation Date" />
                                        <Column field="transportationfrom"  sortable={true} header="Transporation From" />      
                                        <Column field="transportationto"  sortable={true} header="Transporation To" />      
                                        <Column field="Comments"  sortable={true} header="Comments" />                  
                                        <Column body={this.transportactTemplate}  header="Action"/>
                                    </DataTable>
                                </div> */}
                                
                        
                        
                        </div>
                    </div>
                    }
                    { (this.state.actionType === 'Visa') &&
                                <div className="p-col-12">
                                    <div className="card card-w-title">
                                        <h1>Visa Action</h1>
                                        <div className="p-grid ">


                                        { (this.state.visaActionDetails && this.state.visaActionDetails.length > 0) && 
                                        <>
                                        { this.state.visaActionDetails.map((visa,indexVisa) => {
                                        return(
                                            <div className="p-grid" key={indexVisa}>
                                          
                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <InputText className="p-col-12" value={visa.EXITREENTRYVISANUMBER} name={'EXITREENTRYVISANUMBER'} onChange={e => this.changeActions(e,indexVisa,'visa')} placeholder="Exit Reentry Visa No"/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Calendar placeholder="Exit Reentry Issue Date" value={visa.EXITREENTRYVISAISSUEDATE} name="EXITREENTRYVISAISSUEDATE" onChange={e => this.changeActions(e,indexVisa,'visa')} {...CALENDAR_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Calendar placeholder="Exit Reentry Expiry Date" value={visa.EXITREENTRYVISAEXPIRYDATE} name="EXITREENTRYVISAEXPIRYDATE" onChange={e => this.changeActions(e,indexVisa,'visa')} {...CALENDAR_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                    <InputText className="p-col-12" value={visa.VISITINGCOUNTRYVISANUMBER} name={'VISITINGCOUNTRYVISANUMBER'} onChange={e => this.changeActions(e,indexVisa,'visa')} placeholder="Visiting Country Visa No"/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Calendar placeholder="Visiting Country Issue Date" value={visa.VISITINGCOUNTRYISSUEDATE} name="VISITINGCOUNTRYISSUEDATE" onChange={e => this.changeActions(e,indexVisa,'visa')} {...CALENDAR_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Calendar placeholder="Visiting Country Expiry Date" value={visa.VISITINGCOUNTRYEXPIRYDATE} name="VISITINGCOUNTRYEXPIRYDATE" onChange={e => this.changeActions(e,indexVisa,'visa')} {...CALENDAR_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Dropdown placeholder="Select Status" name="visaStatus" value={visa.visaStatus} options={this.props.ActionStatus} onChange={e => this.changeActions(e,indexVisa,'visa')} style={{ width: '100%' }} {...DROPDOWN_CONFIG}/>
                                                    </div> 
                                                </div>

                                                <div className="p-col-12 p-md-12 p-lg-12">
                                                    <div className="mt1">
                                                        <InputTextarea rows={3} className="p-col-12" value={visa.visaComments} name="visaComments" onChange={e => this.changeActions(e,indexVisa,'visa')} cols={30} placeholder="Comments..." autoResize={true} />
                                                    </div> 
                                                </div>
                                            

                                                { <div className="p-col-12 p-md-6 p-lg-3">
                                                    <div className="mt1">
                                                        <Button disabled={!isVisaActionEnabled} className="p-button-primary"  icon="pi pi-check" onClick={this.addVisaAction} label="Save" />
                                                    </div> 
                                                </div> }
                                                
                                                <div className="p-col-12 p-lg-12">  <hr/> </div>
                                            </div>
                                            )
                                         })}
                                        </>
                                    }
                               

                                            { <div className="p-col-12 p-lg-12">
                                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={this.state.visaActionDetails}>                            
                                                    <Column field="visano"  sortable={true} header="Visa No" />
                                                    <Column field="visaissuedate"  sortable={true} header="Issue Date" />
                                                    <Column field="visaexpirydate"  sortable={true} header="Expiry Date" />      
                                                    <Column field="countryvisano"  sortable={true} header="Visiting Country No" />      
                                                    <Column field="countryissuedate"  sortable={true} header="Issue Date" />  
                                                    <Column field="countryexpirydate"  sortable={true} header="Expiry Date" />                         
                                                    <Column field="comments"  sortable={true} header="Comments" />                         
                                                    <Column body={this.visaactTemplate}  header="Action"/>
                                                </DataTable>
                                            </div> }
                                 
                                    
                                    
                                    </div>
                                </div>
                                </div>
                    }
              
                    { (this.state.actionType === 'Iqama') &&
                        <div className="p-col-12">
                                    <div className="card card-w-title">
                                        <h1>Iqama Action</h1>

                                        { (this.state.iqamaActionDetails && this.state.iqamaActionDetails.length > 0) && 
                                        <>
                                        { this.state.iqamaActionDetails.map((iqama,indexIqama) => {
                                        return(
                                            <div className="p-grid" key={indexIqama}>

                                        <div className="p-col-12 p-md-6 p-lg-3">
                                            <div className="mt1">
                                                <Dropdown placeholder="Select Status" name="iqamaStatus" value={iqama.iqamaStatus} options={this.props.ActionStatus} onChange={e => this.changeActions(e,indexIqama,'iqama')}  style={{ width: '100%' }} {...DROPDOWN_CONFIG}/>
                                            </div> 
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-9">
                                            <div className="mt1">
                                                <InputTextarea rows={3} className="p-col-12" value={iqama.iqamaComments} name="iqamaComments" onChange={e => this.changeActions(e,indexIqama,'iqama')}  cols={30} placeholder="Comments..." autoResize={true} />
                                            </div> 
                                        </div>
                                        <div className="p-col-12 p-lg-12">  <hr/> </div>
                                            </div>
                                            )
                                         })}
                                        </>
                                    }
                                      
                                    
                                    
                                    </div>
                                </div>
                    }
                    
                    {/* {(this.state.currentStage===0 && this.state.actionDefenitions.length > 0) && <ViewActions data={this.state.actionDefenitions} status={this.props.ActionStatus}/>} */}
                    
       {(this.props.tableLists.status=='Closed' && this.state.actionDefenitions.length > 0) && <ViewActions data={this.state.actionDefenitions} status={this.props.ActionStatus}/>}
         
              
                    <div  className="p-col-12  p-md-12" style={{textAlign:'left'}} >

                        

                        { (this.state.reqStatus === null || this.state.reqStatus === 'RETURNED TO REQUESTER') && (this.state.allowButton) && this.state.currentStage=== 0 &&
                        <>                    
                            <Button className="p-button-secondary" label="Save" onClick= {() => this.saveRequest('save','','',this.state.hasAttachment,this.state.currentStage)} icon="pi pi-save" />
                            {/* <Button className="p-button-success ml1" disabled={!this.state.hasAcknowledged} label="Submit" onClick= {() => this.saveRequest('submit','','',this.state.hasAttachment,this.state.currentStage)} icon="pi pi-save" /> */}
                           <Button className="p-button-success ml1" label="Submit" onClick= {() => this.saveRequest('submit','','',this.state.hasAttachment,this.state.currentStage)} icon="pi pi-save" />

                    </>
                        }

                        {
                        (this.state.currentStage === 0) &&
                            <Link to="/leave-request-list"><Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" /></Link>
                        }




                    {
                        ((parseInt(this.state.currentStage) === 1 || parseInt(this.state.currentStage) === 2  || parseInt(this.state.currentStage) === 3 || parseInt(this.state.currentStage) === 4 ) && this.state.type ==='edit' && this.state.actionType=== null) &&  (this.state.allowButton) &&  
                        <>
                            {(this.state.reqStatus!=='Canceled') &&
                            
                                <>                

                                {/* <Button label="Cancel" className="p-button-danger ml1"  icon="pi pi-times" onClick= {() => this.saveRequest('cancel','/dashboard')}/> */}
                                <Button disabled={(edstatus && edstatus === 'Closed') ? true : false} className="p-button-success ml1" label="Approve" onClick= {() => this.saveRequest('submit','/dashboard')} icon="pi pi-save" /> 

                                <Button disabled={(edstatus && edstatus === 'Closed') ? true : false} label="Reject" className="p-button-danger ml1"p-button-danger ml1  icon="pi pi-trash" onClick= {() => this.saveRequest('reject','/dashboard','',this.state.hasAttachment,this.state.currentStage)}/>

                                <Button disabled={(edstatus && edstatus === 'Closed') ? true : false} label="Return" className="p-button-warning ml1"  icon="pi pi-replay" onClick= {
                                () => {
                                    this.saveRequest('return','/dashboard','',this.state.hasAttachment,this.state.currentStage);
                                    this.setReturnRequest();
                                }
                                }/>
                                
                                 {/*<Button label="Forward"  className="p-button-primary ml1" icon="pi pi-replay" onClick= {() => this.delegateRequest("Select Forward Person",'forward')} />


                                <Button label="Delegate" className="p-button-info ml1" icon="pi pi-users" onClick= {() => this.delegateRequest("Select Delegate Person",'delegate')} /> */}

                                
                                </>
                            }
                            <Link to="/dashboard"><Button className="p-button-secondary ml1" label="Back" icon="pi pi-arrow-left" /></Link>
                        </>
                    }

                    { this.state.requestactionid!==null  && (this.state.allowButton) &&  
                    // disabled={disabledFun}
                         <>
                        <Link to="/dashboard"><Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" /></Link>
                        <Button  className="p-button-success ml1" label="Submit" onClick= {() => this.saveRequest('actionSubmit','/dashboard','',this.state.hasAttachment,this.state.currentStage)} icon="pi pi-save" /> 
                        </>
                    
                    }

                </div>
   
            </div>
        );
    }
}
// delegate,forward,return, cancel,reject,close

const mapStateToProps = state => {
    return{
        state:state,
        error : state.master.error,
        loading : state.master.loading,
        success : state.master.success,
        loggedUserDetail : state.auth.userObject,
        userPosInfo : state.auth.userPosInfo,
        userPref : state.auth.userPref,
        Employee : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        //TimeoffType : (state.keyword.TimeoffType!==undefined) ? state.keyword.TimeoffType : [],
        Cities : (state.keyword.City!==undefined) ? state.keyword.City : [],
        tableLists : state.master.tableLists,
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
        ActionStatus : (state.keyword.ActionStatus!==undefined) ? state.keyword.ActionStatus : [],
        ActionType : (state.keyword.ActionType!==undefined) ? state.keyword.ActionType : [],
        subordinatesListData: state.master.subordinatesListData,
        dependentDetails : state.master.dependentDetails,
        quotaDetails : state.master.quotaDetails,
        relationType : (state.keyword.relationType!==undefined) ? state.keyword.relationType : [],
        TimeoffType: state.master.timeOffData || [] 
    }
}
 
const mapDispatchToProps = dispatch => {
    return {
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterCommonList : (value) => dispatch(actions.getMasterCommonList(value)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getDependentDetails: (table) => dispatch(actions.getDependentDetails(table)),
        getQuotaDetails: (table) => dispatch(actions.getQuotaDetails(table)),
        getTimeOffData: (data) => dispatch(actions.getTimeOffData(data)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(LeaveRequest);
